const pl = {
  common: {
    loading: "\u0141adowanie...",
    back: "Wstecz",
    next: "Dalej",
    save: "Zapisz",
    cancel: "Anuluj",
    close: "Zamknij",
    send: "Wy\u015Blij",
    submit: "Wy\u015Blij",
    yes: "Tak",
    no: "Nie",
    error: "B\u0142\u0105d",
    success: "Sukces",
    search: "Szukaj",
    more: "Wi\u0119cej",
    less: "Mniej",
    optional: "opcjonalne",
    required: "Wymagane",
    perMonth: "/ miesi\u0105c",
    oneTime: "jednorazowo",
    free: "Bezp\u0142atnie",
    skip: "Pomi\u0144",
    pleaseWait: "Prosz\u0119 czeka\u0107...",
    backToHome: "Powr\u00F3t na stron\u0119 g\u0142\u00F3wn\u0105",
    learnMore: "Dowiedz si\u0119 wi\u0119cej",
    email: "E-mail",
    phone: "Telefon",
    password: "Has\u0142o",
    name: "Imi\u0119",
    selected: "wybrane",
    available: "dost\u0119pne",
    used: "wykorzystane",
    of: "z",
    question: "Pytanie",
    craftBusiness: "Firma rzemie\u015Blnicza",
    forCraftBusinesses: "Dla firm rzemie\u015Blniczych",
    projectInquiry: "Zapytanie projektowe",
    projectInquiries: "Zapytania projektowe",
  },
  header: {
    dashboard: "Panel",
    signOut: "Wyloguj si\u0119",
    completeProfile: "Uzupe\u0142nij profil",
    submitInquiry: "Z\u0142\u00F3\u017C zapytanie",
    signIn: "Zaloguj si\u0119",
    menuOpen: "Otw\u00F3rz menu",
    menuClose: "Zamknij menu",
    registerAsCraft: "Zarejestruj si\u0119 jako firma rzemie\u015Blnicza",
  },
  footer: {
    tagline: "Kwalifikowane zapytania projektowe.\nDla wybranych firm rzemie\u015Blniczych.",
    motto: "Znajd\u017A \u00B7 Po\u0142\u0105cz \u00B7 Buduj",
    platform: "Platforma",
    findCraft: "Znajd\u017A firm\u0119 rzemie\u015Blnicz\u0105",
    submitInquiry: "Z\u0142\u00F3\u017C zapytanie projektowe",
    forCraftBusinesses: "Dla firm rzemie\u015Blniczych",
    aboutUs: "O nas",
    legalAndContact: "Prawne & Kontakt",
    imprint: "Impressum",
    privacy: "Prywatno\u015B\u0107",
    accessibility: "Dost\u0119pno\u015B\u0107",
    contact: "Kontakt",
    copyright: "\u00A9 {{year}} CRAFTFINDUS. Dla firm rzemie\u015Blniczych w Niemczech, Austrii i Szwajcarii.",
  },
  cookies: {
    title: "U\u017Cywamy plik\u00F3w cookie",
    description: "U\u017Cywamy plik\u00F3w cookie, aby zapewni\u0107 najlepsze do\u015Bwiadczenia. Wi\u0119cej informacji w naszej",
    privacyLink: "Polityce prywatno\u015Bci",
    acceptAll: "Zaakceptuj wszystkie",
    configure: "Konfiguruj",
    saveSelection: "Zapisz wyb\u00F3r",
    onlyNecessary: "Tylko niezb\u0119dne",
    necessary: "Niezb\u0119dne",
    necessaryDesc: "Wymagane do dzia\u0142ania strony.",
    analytics: "Analityka",
    analyticsDesc: "Pomagaj\u0105 zrozumie\u0107 korzystanie ze strony.",
    marketing: "Marketing",
    marketingDesc: "Umo\u017Cliwiaj\u0105 spersonalizowan\u0105 reklam\u0119.",
  },
  mobileCta: {
    submitInquiry: "Z\u0142\u00F3\u017C zapytanie",
    craftBusiness: "Firma rzemie\u015Blnicza",
  },
  floatingPhone: {
    question: "Masz pytania? Zadzwo\u0144 do nas:",
    ariaLabel: "Poka\u017C numer telefonu",
  },
  home: {
    seoTitle: "Znajd\u017A firm\u0119 rzemie\u015Blnicz\u0105 i otrzymuj zapytania projektowe",
    seoDesc: "CRAFTFINDUS: Znajd\u017A bezp\u0142atnie odpowiedni\u0105 firm\u0119 rzemie\u015Blnicz\u0105 lub otrzymuj kwalifikowane zapytania. 3 do 5 firm na projekt.",
    heroLabel: "Platforma rzemie\u015Blnicza dla Twojego projektu",
    heroTitle1: "Znajd\u017A odpowiedniego",
    heroTitle2: "rzemie\u015Blnika.",
    heroTitle3: "Bez d\u0142ugiego szukania.",
    heroDesc: "Opisz sw\u00F3j projekt. Znajdziemy 3 do 5 pasuj\u0105cych firm dla Ciebie. Bezp\u0142atnie, w ci\u0105gu 24 godzin.",
    heroCta: "Znajd\u017A rzemie\u015Blnika bezp\u0142atnie",
    heroCtaCraft: "Jestem firm\u0105 rzemie\u015Blnicz\u0105",
    badge100Free: "100% bezp\u0142atnie",
    badgeResponse: "Odpowied\u017A w <24h",
    badgeVerified: "Zweryfikowane firmy",
    tradesLabel: "Tw\u00F3j projekt, nasza sie\u0107",
    tradesTitle: "Znajd\u017A odpowiedniego rzemie\u015Blnika dla ka\u017Cdej bran\u017Cy",
    tradesDesc: "Niezale\u017Cnie od tego, czy to naprawa, nowa budowa czy remont \u2013 {{brand}} znajdzie odpowiedni\u0105 firm\u0119 w Twojej okolicy.",
    tradesCta: "Znajd\u017A rzemie\u015Blnika teraz",
    electrician: "Elektryk",
    electricianDesc: "Instalacja elektryczna, o\u015Bwietlenie, skrzynki bezpiecznik\u00F3w, smart home.",
    plumbing: "Hydraulika i Ogrzewanie",
    plumbingDesc: "Remont \u0142azienki, wymiana ogrzewania, rury \u2013 profesjonalni instalatorzy.",
    roofing: "Dekarze i Ciesiele",
    roofingDesc: "Remont dachu, okna dachowe, wi\u0119\u017Aba dachowa.",
    painting: "Malarze i Pod\u0142ogi",
    paintingDesc: "Malowanie elewacji, tapetowanie, pod\u0142ogi.",
    solar: "Fotowoltaika i Klimatyzacja",
    solarDesc: "Panele s\u0142oneczne, pompy ciep\u0142a, klimatyzacja.",
    construction: "Budownictwo i Wyko\u0144czenia",
    constructionDesc: "Sucha zabudowa, p\u0142ytki, kompletny remont.",
    howLabel: "3 proste kroki",
    howTitle: "Jak znale\u017A\u0107 odpowiedniego rzemie\u015Blnika",
    howDesc: "Bez d\u0142ugiego szukania. Bez niekocz\u0105cych si\u0119 telefon\u00F3w. Przeprowadzimy Ci\u0119 przez proces.",
    step1Title: "Opisz projekt",
    step1Desc: "Odpowiedz na kilka prostych pyta\u0144 \u2013 np. 'Remont \u0142azienki' lub 'Instalacja paneli s\u0142onecznych'.",
    step2Title: "Rzemie\u015Blnicy s\u0105 wybierani",
    step2Desc: "{{brand}} automatycznie znajduje do 5 firm pasuj\u0105cych do Twojego projektu. Z Twojego regionu, z odpowiednim do\u015Bwiadczeniem.",
    step3Title: "Kontaktuj\u0105 si\u0119 z Tob\u0105",
    step3Desc: "Wybrane firmy kontaktuj\u0105 si\u0119 bezpo\u015Brednio, osobi\u015Bcie. Ty decydujesz, kto pasuje najlepiej.",
    benefitsLabel: "Korzy\u015Bci",
    benefitsTitle: "Jedna platforma, dw\u00F3ch zwyci\u0119zc\u00F3w",
    forClients: "Dla klient\u00F3w",
    clientsTitle: "Znale\u017A\u0107 rzemie\u015Blnika: prosto i bezp\u0142atnie",
    clientFree: "Ca\u0142kowicie bezp\u0142atnie",
    clientFreeDesc: "Bez op\u0142at, bez prowizji. P\u0142acisz tylko swojemu rzemie\u015Blnikowi.",
    clientNoJargon: "Bez \u017Cargonu",
    clientNoJargonDesc: "Opisz sw\u00F3j projekt w\u0142asnymi s\u0142owami. My znajdziemy odpowiednie bran\u017Ce.",
    clientFast: "Szybkie odpowiedzi",
    clientFastDesc: "W ci\u0105gu 24 godzin 3 do 5 pasuj\u0105cych firm skontaktuje si\u0119 z Tob\u0105.",
    clientQuality: "Zweryfikowana jako\u015B\u0107",
    clientQualityDesc: "Wszystkie firmy s\u0105 zweryfikowane. Mistrzowie rzemios\u0142a s\u0105 szczeg\u00F3lnie wyr\u00F3\u017Cnieni.",
    clientCta: "Z\u0142\u00F3\u017C bezp\u0142atne zapytanie",
    forProviders: "Dla firm rzemie\u015Blniczych",
    providersTitle: "Kwalifikowane zapytania, bez wysi\u0142ku",
    providerMatched: "Pasuj\u0105ce projekty",
    providerMatchedDesc: "Tylko zapytania pasuj\u0105ce do Twojej bran\u017Cy, regionu i mo\u017Cliwo\u015Bci.",
    providerCompetitors: "Max. 3 do 5 konkurent\u00F3w",
    providerCompetitorsDesc: "Brak platformy masowej. Uczciwe szanse.",
    providerTransparent: "Przejrzyste koszty",
    providerTransparentDesc: "Sta\u0142a cena za zapytanie. Bez op\u0142at miesi\u0119cznych, bez prowizji.",
    providerRate: "Wysoki wska\u017Anik akceptacji",
    providerRateDesc: "Bo matching dzia\u0142a: wysoka jako\u015B\u0107, ma\u0142e straty.",
    providerCta: "Zarejestruj si\u0119 jako firma rzemie\u015Blnicza",
    principlesTitle: "Dlaczego {{brand}}?",
    principle1Num: "01",
    principle1Title: "Bez szukania, bez por\u00F3wnywania",
    principle1Desc: "Nie pokazujemy niesko\u0144czonych list. Nasz algorytm wybiera odpowiednie firmy \u2013 na podstawie danych.",
    principle2Num: "02",
    principle2Title: "Jako\u015B\u0107 ponad ilo\u015B\u0107",
    principle2Desc: "Maksymalnie 3 do 5 firm na projekt. Otrzymujesz prawdziw\u0105 uwag\u0119.",
    principle3Num: "03",
    principle3Title: "Przejrzyste i uczciwe",
    principle3Desc: "Ka\u017Cdy wie, dlaczego match si\u0119 uda\u0142. Uczciwe warunki dla obu stron.",
    statsTitle: "{{brand}} w liczbach",
    stat1Value: "3-5",
    stat1Label: "Firm na projekt",
    stat2Value: "12+",
    stat2Label: "Dost\u0119pnych bran\u017C",
    stat3Value: "<24h",
    stat3Label: "Czas reakcji",
    stat4Value: "0 \u20AC",
    stat4Label: "Koszt dla klient\u00F3w",
    faqLabel: "FAQ",
    faqTitle: "Cz\u0119sto zadawane pytania",
    faqDesc: "Odpowiedzi dla klient\u00F3w i firm rzemie\u015Blniczych.",
    faqForClients: "Dla klient\u00F3w",
    faqForProviders: "Dla firm rzemie\u015Blniczych",
    faqC1Q: "Potrzebuję rzemieślnika, ale nie wiem dokładnie jakiej branży. Czy CRAFTFINDUS jest dla mnie?",
    faqC1A: "Tak, zdecydowanie! CRAFTFINDUS jest stworzony właśnie do tego. Wystarczy opisać swój projekt – znajdziemy odpowiednią branżę i najlepsze firmy dla Ciebie. Całkowicie za darmo.",
    faqC2Q: "Ile kosztuje znalezienie rzemieślnika?",
    faqC2A: "Dla Ciebie jako klienta CRAFTFINDUS jest całkowicie bezpłatny. Składasz zapytanie projektowe, otrzymujesz od 3 do 5 dopasowanych firm rzemieślniczych i sam decydujesz, z kim współpracować.",
    faqC3Q: "Jak szybko otrzymam odpowiedzi na moje zapytanie?",
    faqC3A: "Zazwyczaj wykwalifikowane firmy kontaktują się w ciągu 24 godzin. W pilnych przypadkach często jeszcze szybciej. Otrzymasz maksymalnie od 3 do 5 ofert – starannie wyselekcjonowanych.",
    faqC4Q: "Jakie projekty mogę zgłosić przez CRAFTFINDUS?",
    faqC4A: "Praktycznie wszystkie projekty rzemieślnicze: instalacje elektryczne, hydraulika, ogrzewanie, dachy, wykończenia wnętrz, fotowoltaika, klimatyzacja, malowanie i wiele więcej.",
    faqP1Q: "Co daje mi CRAFTFINDUS jako firmie rzemieślniczej?",
    faqP1A: "Otrzymujesz wstępnie zakwalifikowane zapytania dopasowane do Twojej branży i regionu. Maksymalnie 3 do 5 firm na zapytanie oznacza: mniejszą konkurencję i wyższe wskaźniki zamknięcia.",
    faqP2Q: "Jak działa matching w CRAFTFINDUS?",
    faqP2A: "Nasz algorytm analizuje każde zapytanie i dopasowuje je do Twojego profilu: branża, specjalizacja, region, dostępność i wielkość projektu.",
    faqP3Q: "Ile kosztuje CRAFTFINDUS dla firm rzemieślniczych?",
    faqP3A: "Płacisz tylko przejrzystą, stałą cenę za zaakceptowane zapytanie. Bez opłat miesięcznych, bez prowizji od Twoich zleceń.",
    faqP4Q: "Co wyróżnia CRAFTFINDUS od innych portali rzemieślniczych?",
    faqP4A: "Bez licytacji, bez dumpingu cenowego. W CRAFTFINDUS firmy są wybierane, a nie wyszukiwane. Limit 3 do 5 firm na zapytanie zapewnia uczciwe szanse.",
    ctaLabel: "Zacznij teraz",
    ctaTitle: "Co Ci\u0119 dotyczy?",
    ctaClientTitle: "Szukam rzemie\u015Blnika",
    ctaClientDesc: "Opisz sw\u00F3j projekt. Bezp\u0142atnie znajdziemy odpowiednie firmy.",
    ctaClientBtn: "Z\u0142\u00F3\u017C bezp\u0142atne zapytanie",
    ctaProviderTitle: "Jestem firm\u0105 rzemie\u015Blnicz\u0105",
    ctaProviderDesc: "Otrzymuj wst\u0119pnie zakwalifikowane zapytania pasuj\u0105ce do Twojego profilu.",
    ctaProviderBtn: "Zarejestruj si\u0119 teraz",
  },
  auth: {
    seoTitle: "Logowanie \u2013 Portal rzemie\u015Blniczy",
    seoDesc: "Zaloguj si\u0119 do CRAFTFINDUS \u2013 ekskluzywnego portalu dla kwalifikowanych firm rzemie\u015Blniczych.",
    backToHome: "Powr\u00F3t na stron\u0119 g\u0142\u00F3wn\u0105",
    loginPrompt: "Zaloguj si\u0119 na swoje konto",
    emailLabel: "E-mail",
    emailPlaceholder: "twoj@email.pl",
    passwordLabel: "Has\u0142o",
    passwordPlaceholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    loginBtn: "Zaloguj si\u0119",
    invalidCredentials: "Nieprawid\u0142owe dane logowania. Sprawd\u017A wprowadzone dane.",
    alreadyRegistered: "Ten adres e-mail jest ju\u017C zarejestrowany.",
    registrationSuccess: "Rejestracja udana! Potwierd\u017A sw\u00F3j e-mail.",
    loginSuccess: "Zalogowano pomy\u015Blnie",
    invalidEmail: "Podaj prawid\u0142owy adres e-mail",
    passwordMin: "Has\u0142o musi mie\u0107 co najmniej 6 znak\u00F3w",
  },
  dashboard: {
    title: "Zapytania projektowe",
    subtitle: "Kwalifikowane zapytania dla Twojej firmy",
    tabNew: "Nowe",
    tabInReview: "W trakcie",
    tabCompleted: "Zako\u0144czone",
    tabPayment: "P\u0142atno\u015Bci i Rozliczenia",
    tabProfile: "Profil",
    noNew: "Brak nowych zapyta\u0144",
    noInReview: "Brak zapyta\u0144 w trakcie",
    noCompleted: "Brak zako\u0144czonych zapyta\u0144",
    selectForDetails: "Wybierz zapytanie\ndla szczeg\u00F3\u0142\u00F3w",
    weeklyLimitReached: "Limit tygodniowy osi\u0105gni\u0119ty",
    paymentMissing: "Brak metody p\u0142atno\u015Bci",
    paymentMissingDesc: "Zapytania zostan\u0105 aktywowane po skonfigurowaniu p\u0142atno\u015Bci.",
    setupPayment: "Skonfiguruj teraz \u2192",
    paymentRequired: "Najpierw skonfiguruj metod\u0119 p\u0142atno\u015Bci",
    subscriptionBlocked: "Subskrypcja zablokowana \u2013 doko\u0144cz p\u0142atno\u015B\u0107",
    quotaExhausted: "Limit osi\u0105gni\u0119ty \u2013 kup dodatek lub zmie\u0144 plan",
    acceptError: "B\u0142\u0105d przy akceptacji",
    accepted: "Zapytanie zaakceptowane",
    declined: "Zapytanie odrzucone",
    declineError: "B\u0142\u0105d przy odrzuceniu",
    questionSent: "Pytanie wys\u0142ane",
    completed: "Zapytanie zako\u0144czone",
    completeError: "B\u0142\u0105d przy zamykaniu",
  },
  onboarding: {
    progressCompany: "Firma",
    progressTradesRegion: "Bran\u017Ce i Region",
    progressConfig: "Konfiguracja",
    companyTitle: "Twoja firma",
    companySubtitle: "Podstawowe informacje do profilu",
    companyName: "Nazwa firmy",
    companyNamePlaceholder: "Twoja firma rzemie\u015Blnicza",
    contactPerson: "Osoba kontaktowa",
    contactPersonPlaceholder: "Jan Kowalski",
    masterCraftsman: "Mistrz rzemios\u0142a",
    masterCraftsmanDesc: "Twoja firma jest zarejestrowanym zak\u0142adem mistrza",
    tradesTitle: "Twoje bran\u017Ce",
    tradesSubtitle: "Jakie bran\u017Ce obs\u0142ugujesz?",
    regionTitle: "Twoja lokalizacja",
    regionSubtitle: "Gdzie znajduje si\u0119 Twoja firma?",
    regionLabel: "Region / Kod pocztowy",
    regionPlaceholder: "np. Warszawa, 00-001",
    radiusTitle: "Zasi\u0119g us\u0142ug",
    radiusSubtitle: "Jak daleko je\u017Adzisz do klient\u00F3w?",
    limitTitle: "Limit zapyta\u0144",
    limitSubtitle: "Ile zapyta\u0144 chcesz tygodniowo?",
    limitFocused: "Skoncentrowany",
    limitStandard: "Standardowy",
    limitIntensive: "Intensywny",
    completeTitle: "Zapisz profil firmy",
    summaryCompany: "Firma",
    summaryTrades: "Bran\u017Ce",
    summaryMaster: "Mistrz rzemios\u0142a",
    summaryRadius: "Zasi\u0119g",
    summaryLimit: "Limit",
    summaryPerWeek: "tygodniowo",
    saveProfile: "Zapisz profil firmy",
    saving: "Zapisywanie...",
    profileCreated: "Profil firmy utworzony",
    saveError: "B\u0142\u0105d przy zapisywaniu",
    veryNear: "Bardzo blisko",
    nearCity: "Blisko miasta",
    regional: "Regionalny",
    wide: "Szeroki zasi\u0119g",
    superRegional: "Ponadregionalny",
  },
  inquiry: {
    seoTitle: "Z\u0142\u00F3\u017C zapytanie \u2013 Znajd\u017A kwalifikowane firmy",
    seoDesc: "Złóż zapytanie w CRAFTFINDUS: Opisz swój projekt, a my znajdziemy do 5 kwalifikowanych firm.",
    tradeElektriker: "Elektryk",
    tradeSanitaer: "Hydraulik",
    tradeHeizung: "Ogrzewanie",
    tradeDachdecker: "Dekarz",
    tradeInnenausbau: "Wykończenia wnętrz",
    tradeSchreiner: "Stolarz",
    tradeBauunternehmen: "Firma budowlana",
    tradeFensterbauer: "Montaż okien",
    tradeGartenbau: "Ogrodnictwo",
    tradePhotovoltaik: "Fotowoltaika",
    tradeKlimaanlagen: "Klimatyzacja",
    tradeMalerbetrieb: "Malarz",
    progressDetails: "Szczegóły projektu",
    progressDescription: "Opis",
    progressContact: "Kontakt",
    questionOf: "Pytanie {{current}} z {{total}}",
    tradeTitle: "Jakiej bran\u017Cy potrzebujesz?",
    tradeSubtitle: "Wybierz odpowiedni\u0105 bran\u017C\u0119",
    tradesLoading: "\u0141adowanie bran\u017C...",
    projectTypeTitle: "Typ projektu",
    projectTypeSubtitle: "Co trzeba zrobi\u0107?",
    repair: "Naprawa",
    repairDesc: "Naprawienie istniej\u0105cych uszkodze\u0144",
    newBuild: "Nowa budowa",
    newBuildDesc: "Nowy budynek lub rozbudowa",
    renovation: "Remont",
    renovationDesc: "Remont istniej\u0105cego",
    installation: "Instalacja",
    installationDesc: "Instalacja nowego systemu",
    objectTypeTitle: "Typ obiektu",
    objectTypeSubtitle: "Jaki typ budynku?",
    efh: "Dom jednorodzinny",
    mfh: "Budynek wielorodzinny",
    commercial: "Komercyjny / Biuro",
    industrial: "Przemys\u0142owy",
    publicBuilding: "Budynek publiczny",
    urgencyTitle: "Jak pilny jest Tw\u00F3j projekt?",
    urgencySubtitle: "Ramy czasowe na start",
    immediate: "Natychmiast",
    immediateDesc: "Jak najszybciej",
    oneWeek: "1 tydzie\u0144",
    oneWeekDesc: "W ci\u0105gu najbli\u017Cszych 7 dni",
    oneMonth: "1 miesi\u0105c",
    oneMonthDesc: "W ci\u0105gu najbli\u017Cszych 30 dni",
    flexible: "Elastycznie",
    flexibleDesc: "Brak sta\u0142ych ram czasowych",
    budgetTitle: "Szacunkowy bud\u017Cet",
    budgetSubtitle: "Pomaga w dopasowaniu",
    under2k: "Poni\u017Cej 2 000 \u20AC",
    budget2k10k: "2 000 do 10 000 \u20AC",
    budget10k50k: "10 000 do 50 000 \u20AC",
    over50k: "Powy\u017Cej 50 000 \u20AC",
    budgetUnclear: "Jeszcze niejasne",
    descriptionTitle: "Opisz sw\u00F3j projekt",
    descriptionSubtitle: "Max. 5 000 znak\u00F3w",
    descriptionPlaceholder: "Co trzeba zrobi\u0107? Jakie s\u0105 szczeg\u00F3\u0142y?",
    desiredStart: "Preferowana data rozpocz\u0119cia (opcjonalne)",
    locationTitle: "Gdzie znajduje si\u0119 projekt?",
    locationSubtitle: "Kod pocztowy lub miasto",
    contactTitle: "Twoje dane kontaktowe",
    contactSubtitle: "Do kontaktu przez kwalifikowane firmy",
    contactNameLabel: "Imi\u0119 *",
    contactNamePlaceholder: "Twoje imi\u0119",
    contactEmailLabel: "E-mail *",
    contactPhoneLabel: "Telefon *",
    contactPhonePlaceholder: "+48 ...",
    toSummary: "Przejd\u017A do podsumowania",
    commitTitle: "Przekazanie do 5 kwalifikowanych firm",
    commitDesc: "Twoje zapytanie zostanie przekazane bezpo\u015Brednio do pasuj\u0105cych firm w Twoim regionie.",
    summaryTrade: "Bran\u017Ca",
    summaryProjectType: "Typ projektu",
    summaryUrgency: "Pilno\u015B\u0107",
    summaryLocation: "Lokalizacja",
    summaryBudget: "Bud\u017Cet",
    submitInquiry: "Wy\u015Blij zapytanie",
    submitting: "Wysy\u0142anie...",
    submitSuccess: "Zapytanie wys\u0142ane pomy\u015Blnie",
    submitError: "B\u0142\u0105d przy wysy\u0142aniu",
  },
  thankyou: {
    inquiryTitle: "Twoje zapytanie zosta\u0142o odebrane",
    inquiryDesc: "Dopasowujemy teraz Tw\u00F3j projekt do naszej sieci kwalifikowanych firm.",
    nextStepsTitle: "Co dalej",
    inquiryStep1: "Sprawdzamy Twoje zapytanie i znajdujemy do 5 pasuj\u0105cych firm.",
    inquiryStep2: "Otrzymasz sugestie kontaktowe e-mailem \u2013 zwykle w ci\u0105gu 24 godzin.",
    inquiryStep3: "Swobodnie decydujesz, z kt\u00F3r\u0105 firm\u0105 rozmawia\u0107.",
    urgentContact: "W pilnych sprawach skontaktuj si\u0119 z nami pod",
    registrationTitle: "Rejestracja odebrana!",
    registrationDesc: "Dzi\u0119kujemy za zainteresowanie CRAFTFINDUS.",
    registrationStep1: "Nasz zesp\u00F3\u0142 weryfikuje Twoje dane.",
    registrationStep2: "Po weryfikacji otrzymasz dane logowania e-mailem.",
    registrationStep3: "Mo\u017Cesz si\u0119 wtedy zalogowa\u0107 i natychmiast otrzymywa\u0107 zapytania.",
    reviewTime: "Weryfikacja trwa zwykle 1\u20132 dni robocze.",
    contactTitle: "Dzi\u0119kujemy za wiadomo\u015B\u0107",
    contactDesc: "Otrzymali\u015Bmy Twoje zapytanie i odpowiemy najszybciej jak to mo\u017Cliwe.",
    contactResponse: "Zwykle odpowiadamy w ci\u0105gu 24 godzin w dni robocze.",
    sendAnother: "Wy\u015Blij kolejn\u0105 wiadomo\u015B\u0107",
  },
  contact: {
    seoTitle: "Kontakt \u2013 Skontaktuj si\u0119 z CRAFTFINDUS",
    seoDesc: "Skontaktuj si\u0119 z CRAFTFINDUS: Pytania o zapytania, rejestracj\u0119 lub wsp\u00F3\u0142prac\u0119?",
    title: "Kontakt",
    desc: "Masz pytania o {{brand}} lub chcesz si\u0119 skontaktowa\u0107? Czekamy na Twoj\u0105 wiadomo\u015B\u0107.",
    phoneLabel: "Telefon",
    emailLabel: "E-mail",
    nameLabel: "Imi\u0119 *",
    namePlaceholder: "Twoje imi\u0119",
    emailFieldLabel: "E-mail *",
    emailPlaceholder: "twoj@email.pl",
    subjectLabel: "Temat *",
    subjectPlaceholder: "O czym chodzi?",
    messageLabel: "Wiadomo\u015B\u0107 *",
    messagePlaceholder: "Twoja wiadomo\u015B\u0107...",
    sendBtn: "Wy\u015Blij wiadomo\u015B\u0107",
    sending: "Wysy\u0142anie...",
    sent: "Wiadomo\u015B\u0107 wys\u0142ana!",
    sendFailed: "Wysy\u0142anie nie powiod\u0142o si\u0119. Spr\u00F3buj p\u00F3\u017Aniej.",
    nameRequired: "Podaj swoje imi\u0119",
    emailRequired: "Podaj prawid\u0142owy adres e-mail",
    subjectRequired: "Podaj temat",
    messageMin: "Wiadomo\u015B\u0107 musi mie\u0107 co najmniej 10 znak\u00F3w",
  },
  about: {
    seoTitle: "O CRAFTFINDUS \u2013 Uczciwe i inteligentne dopasowanie",
    seoDesc: "CRAFTFINDUS \u0142\u0105czy klient\u00F3w z kwalifikowanymi firmami rzemie\u015Blniczymi.",
    heroLabel: "O {{brand}}",
    heroTitle1: "Ludzie stoj\u0105cy za",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} powsta\u0142 z prostej obserwacji: Klienci maj\u0105 trudno\u015Bci ze znalezieniem odpowiedniego rzemie\u015Blnika.",
    teamLabel: "Nasz zesp\u00F3\u0142",
    teamTitle: "Ludzie stoj\u0105cy za",
    founderRole: "Za\u0142o\u017Cyciel",
    founderBio1: "Jako przedsi\u0119biorca z Solingen znam obie strony.",
    founderBio2: "{{brand}} to moja odpowied\u017A na ten problem. Platforma oparta na inteligentnym matchingu.",
    chrisRole: "Partner biznesowy",
    chrisBio: "Chris wnosi strategiczne my\u015Blenie i do\u015Bwiadczenie przedsi\u0119biorcze.",
    veronikaRole: "Asystentka zarz\u0105du & Back office",
    veronikaBio: "Veronika koordynuje wszystkie procesy za kulisami.",
    dukeRole: "Pies biurowy & Feel-Good Manager",
    dukeBio: "\u017Badne spotkanie bez Duke'a. Nasz Bull Terrier dba o dobry nastr\u00F3j.",
    valuesLabel: "Nasze warto\u015Bci",
    valuesTitle: "Za czym stoimy",
    value1Title: "Jako\u015B\u0107 ponad ilo\u015B\u0107",
    value1Desc: "Wierzymy w mniej, ale lepszych po\u0142\u0105cze\u0144. Ka\u017Cde zapytanie ograniczamy do 3\u20135 firm.",
    value2Title: "Uczciwo\u015B\u0107 dla obu stron",
    value2Desc: "Bezp\u0142atnie dla klient\u00F3w, przejrzyste sta\u0142e ceny dla firm.",
    value3Title: "Prostota",
    value3Desc: "Rzemios\u0142o jest wystarczaj\u0105co skomplikowane. Upraszczamy drog\u0119 do odpowiedniej firmy.",
    missionLabel: "Nasza misja",
    missionTitle: "Dopasowanie rzemie\u015Blnicze, jakie powinno by\u0107",
    missionP1: "Rynek rzemie\u015Blniczy jest rozdrobniony.",
    missionP2: "{{brand}} robi to inaczej: Wybieramy 3 do 5 pasuj\u0105cych firm na ka\u017Cde zapytanie.",
    missionP3: "Nasz cel: By\u0107 pierwszym punktem kontaktowym w regionie DACH.",
    ctaTitle: "Gotowy, \u017Ceby nas pozna\u0107?",
    ctaDesc: "Niezale\u017Cnie czy szukasz rzemie\u015Blnika, czy chcesz otrzymywa\u0107 zapytania: Czekamy na Ciebie.",
    ctaInquiry: "Z\u0142\u00F3\u017C zapytanie",
    ctaContact: "Skontaktuj si\u0119",
  },
  pricing: {
    seoTitle: "Cennik \u2013 Plany subskrypcyjne dla firm rzemie\u015Blniczych",
    seoDesc: "Przejrzyste plany miesi\u0119czne dla kwalifikowanych zapyta\u0144.",
    heroLabel: "Cennik",
    heroTitle1: "Wi\u0119cej zlece\u0144.",
    heroTitle2: "Mniej przestoj\u00F3w.",
    heroDesc: "Wybierz plan pasuj\u0105cy do Twojej firmy.",
    leadsIncluded: "zaakceptowanych lead\u00F3w w cenie",
    choosePlan: "Wybierz plan",
    mostPopular: "Najpopularniejszy plan",
    addonsLabel: "Dodatki",
    addonsTitle: "Zamów dodatkowe leady",
    radiusLabel: "Rozszerzenia zasięgu",
    radiusTitle: "Powiększ swój obszar działania",
    radiusDesc: "Powiększ swój promień działania i otrzymuj zapytania z większego obszaru.",
    trustNoContract: "Bez zobowiązań",
    landingLabel: "Cennik dla firm rzemieślniczych",
    landingTitle: "Przejrzyste plany subskrypcyjne",
    landingDesc: "Wybierz plan pasujący do Twojej firmy – bez ukrytych kosztów, bez zobowiązań.",
    landingCta: "Zobacz wszystkie plany",
    trustInstant: "Od razu gotowy",
    trustVerified: "Tylko zweryfikowane zapytania",
    faqLabel: "Cz\u0119ste pytania",
    faqTitle: "Pytania o cennik",
    ctaTitle: "Gotowy na nowe zlecenia?",
    ctaDesc: "Zarejestruj si\u0119 bezp\u0142atnie, wybierz plan i otrzymuj pasuj\u0105ce zapytania.",
    ctaBtn: "Zarejestruj si\u0119 teraz",
    faq1q: "P\u0142ac\u0119 tylko przy akceptacji?",
    faq1a: "Nie \u2013 z subskrypcj\u0105 p\u0142acisz sta\u0142\u0105 kwot\u0119 miesi\u0119czn\u0105 z okre\u015Blon\u0105 liczb\u0105 lead\u00F3w.",
    faq2q: "Co si\u0119 dzieje, gdy wyczerpi\u0119 limit?",
    faq2a: "Mo\u017Cesz kupi\u0107 dodatek z dodatkowymi leadami.",
    faq3q: "Czy mog\u0119 zmieni\u0107 plan?",
    faq3a: "Tak, mo\u017Cesz uaktualni\u0107 w dowolnym momencie. Nowy plan zaczyna dzia\u0142a\u0107 natychmiast.",
    faq4q: "Czy jest zobowi\u0105zanie umowne?",
    faq4a: "Nie. Mo\u017Cesz anulowa\u0107 subskrypcj\u0119 w dowolnym momencie na koniec okresu.",
    faq5q: "Co jest specjalnego w planie 'Premium'?",
    faq5a: "Firmy Premium otrzymuj\u0105 odznak\u0119 Zweryfikowany i s\u0105 traktowane priorytetowo.",
  },
  billing: {
    title: "Rozliczenia i Plan",
    subtitle: "Zarz\u0105dzaj planem, limitami i metod\u0105 p\u0142atno\u015Bci",
    tabPlan: "Plan i Rozliczenia",
    tabQuotas: "Limity",
    tabPayment: "Metoda p\u0142atno\u015Bci",
    statusActive: "Aktywny",
    statusTrial: "Okres pr\u00F3bny",
    statusPastDue: "Zaleg\u0142a p\u0142atno\u015B\u0107",
    statusBlocked: "Zablokowany",
    statusCanceled: "Anulowany",
    statusPending: "Oczekuj\u0105cy",
    pastDueBanner: "P\u0142atno\u015B\u0107 nie powiod\u0142a si\u0119. Zaktualizuj metod\u0119 p\u0142atno\u015Bci.",
    blockedBanner: "Subskrypcja zablokowana. Doko\u0144cz p\u0142atno\u015B\u0107.",
    updatePayment: "Zaktualizuj p\u0142atno\u015B\u0107",
    cancelledNotice: "Twoja subskrypcja ko\u0144czy si\u0119 {{date}}.",
    cancelSub: "Anuluj subskrypcj\u0119",
    cancelConfirm: "Czy na pewno chcesz anulowa\u0107 subskrypcj\u0119 na koniec okresu?",
    cancelSuccess: "Subskrypcja zostanie anulowana na koniec okresu",
    noPlan: "Brak aktywnego planu",
    noPlanDesc: "Wybierz plan, aby otrzymywa\u0107 kwalifikowane zapytania.",
    changePlan: "Zmie\u0144 plan",
    selectPlan: "Wybierz plan",
    currentPlan: "Aktualny",
    activePlan: "Aktywny plan",
    leadsIncl: "Lead\u00F3w w cenie",
    addonsTitle: "Dodatki",
    buy: "Kup",
    acceptedLeads: "Zaakceptowane leady",
    deliveries: "Dostawy",
    quotaReached: "Limit osi\u0105gni\u0119ty \u2013 kup dodatek lub zmie\u0144 plan",
    billingPeriod: "Okres rozliczeniowy",
    periodResets: "Limity s\u0105 automatycznie resetowane na pocz\u0105tku ka\u017Cdego okresu.",
  },
  registration: {
    seoTitle: "Zarejestruj firm\u0119 \u2013 Otrzymuj kwalifikowane zapytania",
    seoDesc: "Zarejestruj firm\u0119 rzemie\u015Blnicz\u0105 w CRAFTFINDUS: Gotowy w 15 minut.",
    title: "Zarejestruj si\u0119 jako firma rzemie\u015Blnicza",
    subtitle: "Wype\u0142nij formularz. Po weryfikacji otrzymasz dane logowania e-mailem.",
    requiredFields: "Wymagane pola: Nazwa firmy, osoba kontaktowa, e-mail",
    fillRequired: "Wype\u0142nij nazw\u0119 firmy, osob\u0119 kontaktow\u0105 i e-mail.",
    submitting: "Wysy\u0142anie...",
    submitBtn: "Wy\u015Blij rejestracj\u0119",
    submitError: "B\u0142\u0105d przy wysy\u0142aniu",
  },
  handwerker: {
    seoTitle: "Pozyskuj klient\u00F3w \u2013 Kwalifikowane zapytania bez cold calling",
    seoDesc: "Pozyskuj klient\u00F3w bez cold calling: CRAFTFINDUS dostarcza wst\u0119pnie zakwalifikowane zapytania.",
    heroLabel: "Dla firm rzemie\u015Blniczych i mistrz\u00F3w",
    heroTitle1: "Kwalifikowane zapytania.",
    heroTitle2: "Bez wojny cenowej.",
    heroDesc: "{{brand}} dostarcza wst\u0119pnie zakwalifikowane zapytania od klient\u00F3w, kt\u00F3rzy teraz potrzebuj\u0105 rzemie\u015Blnika.",
    registerFree: "Zarejestruj si\u0119 bezp\u0142atnie",
    badgeNoContract: "Bez zobowi\u0105za\u0144",
    badgeReady: "Gotowy w 15 min",
    badgeVerified: "Tylko zweryfikowane zapytania",
    badgePayOnAccept: "P\u0142atno\u015B\u0107 tylko przy zaakceptowanym projekcie",
    benefitsLabel: "Twoje korzy\u015Bci",
    benefitsTitle: "Dlaczego firmy wybieraj\u0105 {{brand}}",
    benefit1Title: "Precyzyjne dopasowanie",
    benefit1Desc: "Nasz algorytm dopasowuje ka\u017Cde zapytanie do Twojego profilu.",
    benefit2Title: "Max. 3 do 5 firm na projekt",
    benefit2Desc: "Bez masowej dystrybucji. Mniej konkurencji, wy\u017Cszy wska\u017Anik zamkni\u0119\u0107.",
    benefit3Title: "Przejrzyste sta\u0142e ceny",
    benefit3Desc: "P\u0142acisz tylko za zaakceptowane zapytanie \u2013 sta\u0142a, przejrzysta cena.",
    benefit4Title: "Wst\u0119pnie zakwalifikowane zapytania",
    benefit4Desc: "Ka\u017Cde zapytanie jest weryfikowane przed przekazaniem.",
    benefit5Title: "Przewidywalny wzrost",
    benefit5Desc: "Sam decydujesz, ile zapyta\u0144 akceptujesz miesi\u0119cznie.",
    benefit6Title: "Szybki dost\u0119p",
    benefit6Desc: "Zarejestruj si\u0119, stw\u00F3rz profil, otrzymuj zapytania. Gotowy w 15 minut.",
    pricingLabel: "Przyk\u0142ady cen",
    pricingTitle: "Przejrzyste sta\u0142e ceny za zapytanie",
    pricingDesc: "P\u0142acisz tylko za zapytania, kt\u00F3re aktywnie akceptujesz.",
    smallProjects: "Ma\u0142e projekty",
    smallExamples: "np. gniazdka, krany, malowanie \u015Bcian",
    mediumProjects: "\u015Arednie i du\u017Ce projekty",
    mediumExamples: "np. remont \u0142azienki, panele s\u0142oneczne, remont dachu, kompletny remont",
    priceFrom: "od {{price}} \u20AC",
    perAcceptedInquiry: "za zaakceptowane zapytanie",
    goodToKnow: "Warto wiedzie\u0107",
    goodToKnow1: "Bez op\u0142at miesi\u0119cznych. P\u0142atno\u015B\u0107 tylko przy akceptacji",
    goodToKnow2: "Wielko\u015B\u0107 projektu okre\u015Bla cen\u0119 \u2013 widoczna z g\u00F3ry",
    goodToKnow3: "Reklamacja przy b\u0142\u0119dnej kwalifikacji \u2013 zwrot gwarantowany",
    goodToKnow4: "Rozliczenie przez zapisan\u0105 metod\u0119 p\u0142atno\u015Bci",
    howLabel: "Jak to dzia\u0142a",
    howTitle: "3 kroki do nowych projekt\u00F3w",
    step1Title: "Stw\u00F3rz profil",
    step1Desc: "Bran\u017Ca, region, mo\u017Cliwo\u015Bci i specjalizacja.",
    step2Title: "Otrzymuj zapytania",
    step2Desc: "Pasuj\u0105ce projekty s\u0105 dostarczane automatycznie.",
    step3Title: "Akceptuj i kontaktuj si\u0119",
    step3Desc: "Ty decydujesz, kt\u00F3re projekty akceptujesz i rozmawiasz bezpo\u015Brednio z klientem.",
    startNow: "Zacznij teraz",
    faqLabel: "Cz\u0119ste pytania",
    faqTitle: "Pytania od firm rzemie\u015Blniczych",
    ctaTitle: "Gotowy na kwalifikowane zapytania?",
    ctaDesc: "Zarejestruj si\u0119 bezp\u0142atnie i otrzymuj pasuj\u0105ce projekty \u2013 bez zobowi\u0105za\u0144.",
    ctaBtn: "Zarejestruj si\u0119 bezp\u0142atnie",
  },
  notFound: {
    title: "Strona nie znaleziona",
    description: "\u017B\u0105dana strona nie istnieje.",
  },
  limitReached: {
    title: "Pauza",
    subtitle: "Tw\u00F3j limit tygodniowy zosta\u0142 osi\u0105gni\u0119ty.",
    nextReset: "Nast\u0119pne odblokowanie",
    description: "Limit chroni jako\u015B\u0107 platformy.",
    adjustLimit: "Dostosuj limit",
  },
  skipLink: "Przejdź do głównej treści",
  portal: {
    switchPortal: "Zmień portal", profile: "Profil", changePassword: "Zmień hasło",
    signOut: "Wyloguj się", newPassword: "Nowe hasło", passwordPlaceholder: "Minimum 6 znaków",
    saving: "Zapisywanie...", saveBtn: "Zapisz", cancelBtn: "Anuluj",
  },
  opportunityDetail: {
    company: "Firma", confidentialUntilAccept: "Poufne do akceptacji", notSpecified: "Nie podano",
    urgency: "Pilność", decision: "Decyzja", matchScore: "Wynik dopasowania", location: "Lokalizacja",
    remote: "Zdalnie", remotePossible: "Możliwe", onsite: "Na miejscu", compliance: "Zgodność",
    complianceRelevant: "Istotne", onsiteLabel: "Na miejscu", onsiteRequired: "Wymagane",
    context: "Kontekst", whySelected: "Dlaczego zostałeś wybrany", inquiryAccess: "Dostęp do zapytania",
    accepting: "Akceptowanie...", acceptInquiry: "Zaakceptuj zapytanie", decline: "Odrzuć",
    responseWindow: "Okno odpowiedzi: zalecane 2h", claimLabel: "Reklamacja", claimBtn: "Złóż reklamację",
    completed: "Zakończone", won: "Wygrane", lost: "Przegrane", noFit: "Brak dopasowania",
    claimApproved: "Zatwierdzono", claimRejected: "Odrzucono", claimUnderReview: "W trakcie przeglądu",
    claimSubmitted: "Złożono", submittedAt: "Złożono dnia", decidedAt: "Zdecydowano dnia",
    reason: "Powód", rejectionReason: "Powód odrzucenia", note: "Uwaga",
    expiresIn: "Wygasa za {{hours}}h", expired: "Wygasło",
  },
  regForm: {
    companyData: "Dane firmy", companyName: "Nazwa firmy *", companyNamePlaceholder: "Twoja firma",
    companyType: "Typ firmy", companyTypePlaceholder: "– Wybierz –", legalName: "Nazwa prawna",
    legalNamePlaceholder: "np. z rejestru", contactPerson: "Osoba kontaktowa *", contactPersonPlaceholder: "Twoje imię",
    role: "Rola / Stanowisko", rolePlaceholder: "np. Dyrektor", email: "E-mail *", emailPlaceholder: "twoj@email.pl",
    phone: "Telefon", phonePlaceholder: "+48 ...", website: "Strona www", websitePlaceholder: "https://...",
    invoiceEmail: "E-mail do faktur", invoiceEmailPlaceholder: "ksiegowosc@firma.pl",
    address: "Adres", street: "Ulica i numer", postalCode: "Kod pocztowy", city: "Miasto", country: "Kraj",
    countryDE: "Niemcy", countryAT: "Austria", countryCH: "Szwajcaria",
    vatId: "NIP", vatIdPlaceholder: "PL1234567890",
    contacts: "Osoby kontaktowe", contactsDesc: "Opcjonalnie: Dodatkowe osoby kontaktowe",
    addContact: "Dodaj kontakt", noContacts: "Brak dodatkowych osób kontaktowych",
    createContact: "Utwórz kontakt", contactN: "Kontakt {{n}}", primaryContact: "Kontakt główny",
    setPrimary: "Ustaw jako główny", nameRequired: "Imię *", emailRequired: "E-mail *", rolePlaceholderShort: "np. Sprzedaż",
  },
  stackPicker: { noResults: "Nie znaleziono technologii", addCustom: "Dodaj własną technologię", customPlaceholder: "np. SAP, DATEV..." },
  thankyouExtra: { orVia: "lub przez", emailLabel: "E-mail" },
  pdExtra: { slaResponseTime: "Czas reakcji SLA" },
  completionDialog: {
    confirmTitle: "Zamknij zapytanie",
    confirmDesc: "Czy zapytanie jest zako\u0144czone i kontakt z klientem zako\u0144czony?",
    confirmYes: "Tak, zamknij",
    confirmNo: "Nie, wr\u00F3\u0107",
    outcomeTitle: "Wynik",
    outcomeDesc: "Czy dosz\u0142o do zlecenia?",
    won: "Tak \u2013 Zlecenie wygrane",
    lost: "Nie \u2013 Zlecenie przegrane",
    noFit: "Brak dopasowania / Nie kontynuowano",
  },
  suche: {
    seoTitle: "Znajd\u017A rzemie\u015Blnika \u2013 bezp\u0142atnie i bez rejestracji",
    seoDesc: "Znajd\u017A odpowiedniego rzemie\u015Blnika: bezp\u0142atnie, niezobowi\u0105zuj\u0105co i zgodnie z RODO.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED Region DACH",
    trustFree: "100% za darmo",
    trustGdpr: "Zgodne z RODO",
    trustConsent: "Brak udost\u0119pniania bez zgody",
    heroTitle: "Znajd\u017A odpowiedniego rzemie\u015Blnika.",
    heroAccent: "Bezp\u0142atnie, niezobowi\u0105zuj\u0105co i bez rejestracji",
    heroDesc: "Znajdujemy odpowiednich rzemie\u015Blnik\u00F3w z Twojego regionu dzi\u0119ki inteligentnemu dopasowaniu.",
    heroCta: "Znajd\u017A rzemie\u015Blnika teraz",
    heroSubline: "Bezp\u0142atnie \u00B7 Niezobowi\u0105zuj\u0105co \u00B7 Odpowied\u017A w ci\u0105gu 24h",
    howBtn: "Jak dzia\u0142a {{brand}}?",
    howTitle: "Jak dzia\u0142a {{brand}}?",
    howIntro: "{{brand}} \u0142\u0105czy zleceniodawc\u00F3w z wykwalifikowanymi rzemie\u015Blnikami w regionie DACH.",
    howStep1: "Opisujesz sw\u00F3j projekt",
    howStep1Desc: "w kilku krokach, bez \u017Cargonu technicznego.",
    howStep2: "Inteligentne dopasowanie",
    howStep2Desc: "nasz algorytm znajduje odpowiednie firmy z Twojego regionu.",
    howStep3: "Walidacja ludzka",
    howStep3Desc: "ka\u017Cde dopasowanie jest weryfikowane przed wys\u0142aniem.",
    howStep4: "Do 5 firm si\u0119 z Tob\u0105 skontaktuje",
    howStep4Desc: "osobi\u015Bcie i bezpo\u015Brednio.",
    howFreeTitle: "Ca\u0142kowicie bezp\u0142atnie dla Ciebie",
    howFreeDesc: "Koszty ponosi rzemie\u015Blnik.",
    problemsTitle: "Znasz ten",
    problemsAccent: "problem",
    problemsSuffix: ". My znajdziemy rozwi\u0105zanie",
    problemsDesc: "Nie potrzebujesz wiedzy fachowej. Po prostu opisz, co trzeba zrobi\u0107.",
    problem1: "Awaria ogrzewania lub potrzeba hydraulika",
    problem2: "Instalacja elektryczna lub panele s\u0142oneczne",
    problem3: "Naprawa lub wymiana dachu",
    problem4: "Prace wewn\u0119trzne, suchej zabudowy lub malarskie",
    problem5: "Wymiana okien, drzwi lub elewacji",
    problem6: "Prace ogrodnicze lub krajobrazowe",
    problemsCta: "Opisz sw\u00F3j projekt teraz",
    problemsCtaSub: "Nie wymaga wiedzy fachowej \u00B7 Prowadzony proces",
    stepsTitle: "W 3 krokach do",
    stepsAccent: "odpowiedniego rzemie\u015Blnika",
    stepsDesc: "Tak prosto dzia\u0142a {{brand}} dla Ciebie",
    step1Title: "Opisz projekt",
    step1Desc: "Opisz w kilku krokach, jakiej us\u0142ugi potrzebujesz.",
    step2Title: "Dopasujemy za Ciebie",
    step2Desc: "Nasz algorytm znajduje odpowiednie firmy z Twojego regionu.",
    step3Title: "Otrzymaj oferty",
    step3Desc: "W ci\u0105gu 24 godzin do 5 firm skontaktuje si\u0119 z Tob\u0105.",
    stepsBanner: "Ca\u0142kowicie bezp\u0142atnie \u00B7 Brak ukrytych koszt\u00F3w \u00B7 Brak prowizji",
    exampleTitle: "Tak wygl\u0105da",
    exampleAccent: "zapytanie projektowe",
    exampleSuffix: "",
    exampleLabel: "Przyk\u0142adowe zapytanie projektowe",
    exampleName: "Kompletna renowacja \u0142azienki",
    exampleRegion: "Solingen",
    exampleObject: "Dom jednorodzinny",
    exampleUrgency: "W ci\u0105gu 1 miesi\u0105ca",
    exampleMatched: "Znaleziono 4 pasuj\u0105ce firmy",
    regionLabel: "Region",
    objectLabel: "Obiekt",
    timeframeLabel: "Ramy czasowe",
    resultLabel: "Wynik",
    exampleResult: "W ci\u0105gu <strong>24 godzin</strong> ten zleceniodawca otrzyma\u0142 4 pasuj\u0105ce oferty.",
    exampleCta: "Z\u0142\u00F3\u017C w\u0142asne zapytanie",
    whyTitle: "Dlaczego zleceniodawcy u\u017Cywaj\u0105 {{brand}}",
    why1: "Ca\u0142kowicie bezp\u0142atnie, bez ukrytych op\u0142at",
    why2: "Przetwarzanie danych zgodne z RODO w Niemczech",
    why3: "Twoje dane s\u0105 udost\u0119pniane dopiero po wyra\u017Ceniu zgody (maks. 5)",
    why4: "Starannie wybrane firmy, maks. 5 na zapytanie",
    why5: "Odpowied\u017A w ci\u0105gu 24 godzin",
    why6: "Osobiste wsparcie w razie pyta\u0144",
    whyTrust: "Zaufane przez zleceniodawc\u00F3w z regionu DACH",
    ctaTitle: "Gotowy znale\u017A\u0107 odpowiedniego",
    ctaAccent: "rzemie\u015Blnika",
    ctaSuffix: "?",
    ctaDesc: "Opisz sw\u00F3j projekt. My zajmiemy si\u0119 reszt\u0105.",
    ctaBtn: "Znajd\u017A rzemie\u015Blnika teraz",
    ctaSubline: "Bezp\u0142atnie \u00B7 Niezobowi\u0105zuj\u0105co \u00B7 Odpowied\u017A w ci\u0105gu 24h",
    ctaPhone: "Masz pytania? Zadzwo\u0144 pod",
    ctaForCraft: "Dla rzemie\u015Blnik\u00F3w \u2192",
    ctaForLeads: "Zapytania projektowe dla firm \u2192",
    ctaContact: "Kontakt \u2192",
  },
  leads: {
    seoTitle: "Otrzymuj zapytania projektowe \u2013 Kwalifikowane zlecenia",
    seoDesc: "Prekwalifikowane zapytania projektowe z regionu DACH.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED Region DACH",
    trustGdpr: "Zgodne z RODO",
    trustMax5: "Maks. 5 firm na zapytanie",
    trustPayOnAccept: "P\u0142atno\u015B\u0107 dopiero po akceptacji",
    trustNoSubs: "Brak abonament\u00F3w",
    trustCancelAnytime: "Mo\u017Cliwo\u015B\u0107 rezygnacji w ka\u017Cdej chwili",
    heroTitle: "Kwalifikowane zapytania projektowe z Twojego regionu.",
    heroAccent: "P\u0142acisz tylko, gdy akceptujesz",
    heroDesc: "Brak zimnych telefon\u00F3w. Brak abonament\u00F3w.\nTylko prawdziwe zapytania z DACH.",
    heroCta: "Rozpocznij bezp\u0142atn\u0105 rejestracj\u0119",
    heroSubline: "Bez koszt\u00F3w \u00B7 Bez zobowi\u0105za\u0144 \u00B7 P\u0142atno\u015B\u0107 po akceptacji",
    benefitsTitle: "Twoje korzy\u015Bci jako",
    benefitsAccent: "rzemie\u015Blnik",
    benefit1Title: "Prawdziwe zapytania projektowe",
    benefit1Desc: "Prekwalifikowane zapytania z realnym zapotrzebowaniem.",
    benefit2Title: "Pe\u0142na kontrola",
    benefit2Desc: "Sam decydujesz, kt\u00F3re zapytania akceptujesz.",
    benefit3Title: "P\u0142atno\u015B\u0107 po akceptacji",
    benefit3Desc: "Koszty powstaj\u0105 dopiero po aktywnej akceptacji.",
    benefitsCta: "Rozpocznij bezp\u0142atn\u0105 rejestracj\u0119",
    howTitle1: "Prosto. Przejrzy\u015Bcie.",
    howAccent: "Uczciwie.",
    howDesc: "Jak dzia\u0142a {{brand}}: w trzech krokach",
    howStep1: "Rejestracja zapytania",
    howStep1Desc: "Klient opisuje sw\u00F3j projekt.",
    howStep2: "Inteligentne dopasowanie",
    howStep2Desc: "Nasz algorytm wybiera firmy, kt\u00F3re naprawd\u0119 pasuj\u0105.",
    howStep3: "Ty decydujesz",
    howStep3Desc: "Widzisz zapytanie z wyprzedzeniem i p\u0142acisz tylko przy akceptacji.",
    howBanner: "Bez abo \u00B7 Bez minimum \u00B7 Bez zobowi\u0105za\u0144",
    faqQ1: "Co oznacza \u201Ekwalifikowane zapytanie\u201D?",
    faqA1: "Zapytanie z realn\u0105 potrzeb\u0105 projektow\u0105.",
    faqQ2: "Kiedy powstaj\u0105 koszty?",
    faqA2: "Dopiero po aktywnej akceptacji zapytania.",
    faqQ3: "Czy mog\u0119 odrzuca\u0107 zapytania?",
    faqA3: "Tak, w ka\u017Cdej chwili i bez koszt\u00F3w.",
    trustTitle: "Dlaczego rzemie\u015Blnicy",
    trustAccent: "wybieraj\u0105 {{brand}}",
    trust1: "Brak przedp\u0142aty",
    trust2: "Przejrzyste informacje o projekcie przed decyzj\u0105",
    trust3: "Region i specjalizacje konfigurowalne indywidualnie",
    trust4: "Sprawiedliwy podzia\u0142, bez przeci\u0105\u017Cenia leadami",
    trust5: "Gwarantowana wymiana przy b\u0142\u0119dnej kwalifikacji",
    trustCta: "Rozpocznij bezp\u0142atn\u0105 rejestracj\u0119",
    exampleTitle: "Tak wygl\u0105da",
    exampleAccent: "zapytanie projektowe",
    exampleSuffix: "",
    exampleLabel: "Nowe zapytanie projektowe",
    exampleName: "Renowacja \u0142azienki dom jednorodzinny",
    exampleMax5: "To zapytanie zosta\u0142o wys\u0142ane do maks. <strong>5 firm</strong>.",
    exampleCta: "Otrzymuj takie zapytania",
    regionLabel: "Region",
    tradeLabel: "Bran\u017Ca",
    budgetLabel: "Bud\u017Cet",
    urgencyLabel: "Pilno\u015B\u0107",
    objectLabel: "Obiekt",
    securityTitle: "Zaufanie jest",
    securityAccent: "podstaw\u0105",
    security1: "Przetwarzanie danych zgodne z RODO w Niemczech",
    security2: "Brak udost\u0119pniania danych kontaktowych bez Twojej zgody",
    security3: "Osobiste wsparcie i jasne zasady",
    security4: "Przejrzyste ceny za zapytanie",
    securityTrust: "Zaufane przez klient\u00F3w pilota\u017Cowych w regionie DACH",
    ctaTitle: "Gotowy na prawdziwe",
    ctaAccent: "zapytania projektowe?",
    ctaDesc: "Zarejestruj si\u0119 i sam zdecyduj, kt\u00F3re zapytania chcesz akceptowa\u0107.",
    ctaBtn: "Rozpocznij bezp\u0142atn\u0105 rejestracj\u0119",
    ctaSubline: "Bez koszt\u00F3w \u00B7 Bez zobowi\u0105za\u0144 \u00B7 Rezygnacja w ka\u017Cdej chwili",
    ctaForCraft: "Korzy\u015Bci dla rzemie\u015Blnik\u00F3w \u2192",
    ctaForSearch: "Dla szukaj\u0105cych projekt\u00F3w \u2192",
    ctaAbout: "O CRAFTFINDUS \u2192",
  },
  feedback: {
    seoThankYou: "Feedback \u2013 Dzi\u0119kujemy",
    thankYouTitle: "Dzi\u0119kujemy!",
    thankYouDesc: "Twoja opinia zosta\u0142a przes\u0142ana pomy\u015Blnie.",
    errorTitle: "B\u0142\u0105d",
    invalidLink: "Nieprawid\u0142owy lub wygas\u0142y link.",
    formTitle: "Twoja opinia",
    formDesc: "Oce\u0144 swoje do\u015Bwiadczenie z <strong>{{provider}}</strong>",
    submitBtn: "Wy\u015Blij opini\u0119",
    submitting: "Wysy\u0142anie\u2026",
    anonymous: "Twoja opinia jest anonimowa dla us\u0142ugodawcy.",
    answerPlaceholder: "Twoja odpowied\u017A\u2026",
  },
  withdraw: {
    seoTitle: "Wycofaj zapytanie",
    seoDesc: "Wycofaj swoje zapytanie projektowe w CRAFTFINDUS.",
    loading: "Weryfikacja linku\u2026",
    errorTitle: "Nieprawid\u0142owy link",
    noToken: "Nie podano tokena.",
    alreadyTitle: "Ju\u017C wycofano",
    alreadyDesc: "To zapytanie zosta\u0142o ju\u017C anulowane.",
    title: "Wycofaj zapytanie",
    confirmQuestion: "Czy na pewno chcesz wycofa\u0107 nast\u0119puj\u0105ce zapytanie?",
    requestNumber: "Nr zapytania",
    category: "Kategoria",
    company: "Firma",
    createdAt: "Utworzono",
    reasonLabel: "Pow\u00F3d",
    reasonPlaceholder: "Dlaczego chcesz wycofa\u0107 zapytanie?",
    reasonMin: "Wymagane minimum 5 znak\u00F3w",
    warning: "Wycofanie spowoduje powiadomienie wszystkich przypisanych firm i anulowanie zapytania. Ta czynno\u015B\u0107 jest nieodwracalna.",
    submitBtn: "Definitywnie wycofaj zapytanie",
    submitting: "Wycofywanie zapytania\u2026",
    successTitle: "Zapytanie wycofane",
    successDesc: "Twoje zapytanie zosta\u0142o pomy\u015Blnie anulowane.",
    notifiedOne: "{{count}} przypisana firma zosta\u0142a powiadomiona.",
    notifiedMany: "{{count}} przypisanych firm zosta\u0142o powiadomionych.",
  },
  profileEdit: {
    title: "Edytuj profil",
    subtitle: "Dane firmy, adres, kontakt, bran\u017Ce i limity",
    companySection: "Firma",
    companyName: "Nazwa firmy *",
    companyType: "Typ firmy",
    companyTypePlaceholder: "\u2013 Wybierz \u2013",
    legalName: "Nazwa prawna",
    legalNamePlaceholder: "np. Przyk\u0142ad Sp. z o.o.",
    vatId: "NIP",
    vatIdPlaceholder: "PL1234567890",
    website: "Strona internetowa",
    addressSection: "Adres",
    street: "Ulica i numer",
    postalCode: "Kod pocztowy",
    city: "Miasto",
    country: "Kraj",
    contactSection: "G\u0142\u00F3wny kontakt",
    contactName: "Osoba kontaktowa *",
    contactRole: "Rola",
    contactRolePlaceholder: "np. Dyrektor",
    contactEmail: "E-mail",
    contactPhone: "Telefon",
    contactPhonePlaceholder: "+48 ...",
    additionalContacts: "Dodatkowe kontakty",
    additionalContactsDesc: "Dodatkowe osoby kontaktowe w Twojej firmie",
    addContact: "Dodaj",
    createContact: "Utw\u00F3rz kontakt",
    noContacts: "Brak dodatkowych kontakt\u00F3w",
    contactLabel: "Kontakt {{n}}",
    primaryContact: "G\u0142\u00F3wny kontakt",
    nameRequired: "Imi\u0119 *",
    emailRequired: "E-mail *",
    tradesSection: "Bran\u017Ce i us\u0142ugi",
    tradesLabel: "Bran\u017Ce",
    stackLabel: "Stack technologiczny",
    stackLoading: "\u0141adowanie tag\u00F3w...",
    limitsSection: "Limit miesi\u0119czny",
    monthlyLimit: "Limit miesi\u0119czny",
    monthlyLimitDesc: "Maksymalna liczba zapyta\u0144 projektowych na miesi\u0105c, kt\u00F3re chcesz otrzymywa\u0107.",
    monthlyLimitUnit: "Zapyta\u0144 / miesi\u0105c",
    noProfile: "Nie znaleziono profilu.",
    createProfile: "Utw\u00F3rz profil",
    saved: "Profil zapisany",
    saveError: "B\u0142\u0105d podczas zapisywania",
    notLoggedIn: "Nie zalogowano",
    saving: "Zapisywanie...",
    saveBtn: "Zapisz profil",
  },
  sucheHeader: {
    cta: "Znajd\u017A rzemie\u015Blnika",
    logoAlt: "CRAFTFINDUS | Znajd\u017A rzemie\u015Blnika",
  },
  leadsHeader: {
    cta: "Otrzymuj zapytania",
    ctaTooltip: "Sam decydujesz, kt\u00F3re zapytania akceptujesz",
    logoAlt: "CRAFTFINDUS | Kwalifikowane zapytania projektowe",
  },
  leadsFooter: {
    imprint: "Impressum",
    privacy: "Prywatno\u015B\u0107",
    contact: "Kontakt",
    faq: "FAQ",
    forCraft: "Dla firm rzemie\u015Blniczych",
    motto: "Znajd\u017A \u00B7 Po\u0142\u0105cz \u00B7 Rozwi\u0105\u017C",
  },
  op: {
    loadingPortal: "\u0141adowanie portalu operatora...",
    portalLabel: "CRAFTFINDUS Operator",
    roleLabel: "Operator",
    ctaNewProvider: "Dodaj now\u0105 firm\u0119",
    ctaNewProviderDesc: "Dodaj firm\u0119 rzemie\u015Blnicz\u0105",
    navDashboard: "Dashboard",
    navRegistrations: "Rejestracje",
    navRequests: "Zapytania projektowe",
    navProviders: "Firmy rzemie\u015Blnicze",
    navOpportunities: "Matching projekt\u00F3w",
    navClaims: "Reklamacje",
    navBilling: "Rozliczenia",
    navCosts: "Przegl\u0105d koszt\u00F3w",
    navPricing: "Cennik",
    navMatching: "Matching",
    navSettings: "Ustawienia",
    navAudit: "Dziennik audytu",
    navSales: "Dashboard sprzeda\u017Cy",
    navROI: "Kalkulator ROI",
    navFeedback: "Feedback",
    dashTitle: "Dashboard",
    dashSubtitle: "Przegl\u0105d wszystkich aktywno\u015Bci",
    realtimeActive: "Czas rzeczywisty aktywny – Nowe zapytania s\u0105 automatycznie dopasowywane",
    realtimeConnecting: "\u0141\u0105czenie…",
    kpiNew7d: "Nowe projekty (7d)",
    kpiDelivered7d: "Dostarczone (7d)",
    kpiFailed: "Nieudane",
    kpiClaimsOpen: "Otwarte reklamacje",
    kpiBlocked: "Zablokowane firmy",
    kpiRevenue: "Przych\u00F3d (miesi\u0105c)",
    liveMatching: "Matching na \u017Cywo",
    waitingForRequests: "Oczekiwanie na nowe zapytania…",
    recentRequests: "Ostatnie zapytania",
    noRequests: "Brak zapyta\u0144",
    openClaims: "Otwarte reklamacje",
    noOpenClaims: "Brak otwartych reklamacji",
    provTitle: "Firmy",
    provSubtitle: "Zarz\u0105dzaj firmami rzemie\u015Blniczymi",
    filterAll: "Wszystkie",
    filterActive: "Aktywne",
    filterPending: "Oczekuj\u0105ce",
    filterSuspended: "Zawieszone",
    filterPastDue: "Przeterminowane",
    createProvider: "+ Dodaj firm\u0119",
    colProvider: "Firma",
    colContact: "Kontakt",
    colRegion: "Region",
    colStatus: "Status",
    colBilling: "Rozliczenia",
    colSEPA: "SEPA",
    colMandate: "Mandat",
    colLimit: "Limit",
    colCreated: "Utworzono",
    statusActive: "Aktywny",
    statusPending: "Oczekuj\u0105cy",
    statusSuspended: "Zawieszony",
    noProviders: "Nie znaleziono firm",
    reqTitle: "Zapytania projektowe",
    reqSubtitle: "Wszystkie otrzymane zapytania",
    reqDetailTitle: "Szczeg\u00F3\u0142y zapytania",
    backToList: "Powr\u00F3t do listy",
    filterUnmatched: "Niedopasowane",
    filterMatched: "Dopasowane",
    colNumber: "Nr",
    colCategory: "Kategoria",
    colCompany: "Firma",
    colUrgency: "Pilno\u015B\u0107",
    colPrice: "Cena",
    colDate: "Data",
    matched: "Dopasowane",
    open: "Otwarte",
    catSupport: "Drobna naprawa",
    catManaged: "Umowa serwisowa",
    catProject: "Projekt budowlany",
    catSecurity: "Pogotowie",
    catCloud: "Renowacja",
    urgImmediate: "Natychmiast",
    urgWithin48h: "48 godzin",
    urgWithin7d: "7 dni",
    urgPlanned: "Planowane",
    decSelf: "Sam",
    decTeam: "Zesp\u00F3\u0142",
    decRecommend: "Rekomendacja",
    labelCategory: "Kategoria",
    labelUrgency: "Pilno\u015B\u0107",
    labelRegion: "Region",
    labelRemote: "Zdalnie",
    labelOnsite: "Na miejscu",
    labelCompliance: "Zgodno\u015B\u0107",
    labelDecision: "Decyzja",
    labelBudget: "Bud\u017Cet",
    labelPrice: "Cena",
    labelProjectSize: "Wielko\u015B\u0107 projektu",
    labelSystems: "Systemy",
    labelUsers: "U\u017Cytkownicy",
    labelDescription: "Opis",
    labelContext: "Kontekst",
    labelStackTags: "Tagi bran\u017Cowe",
    labelOpportunities: "Szanse",
    labelMatchRuns: "Cykle dopasowa\u0144",
    labelRequester: "Wnioskodawca",
    labelRiskFlags: "Flagi ryzyka",
    selected: "wybranych",
    startMatching: "Rozpocznij dopasowanie",
    matchingRunning: "Dopasowanie trwa...",
    matchingStarted: "Dopasowanie rozpocz\u0119te",
    matchingFailed: "Dopasowanie nieudane",
    deleteRequest: "Usu\u0144 zapytanie",
    deleteRequestTitle: "Usun\u0105\u0107 zapytanie?",
    deleteRequestDesc: "Zapytanie <strong>{{number}}</strong> i wszystkie powi\u0105zane dane zostan\u0105 trwale usuni\u0119te.",
    cancelAction: "Anuluj",
    deleting: "Usuwanie...",
    deleteForever: "Usu\u0144 trwale",
    requestDeleted: "Zapytanie {{number}} usuni\u0119te",
    deleteError: "B\u0142\u0105d podczas usuwania",
    loadError: "B\u0142\u0105d podczas \u0142adowania zapyta\u0144",
    requestNotFound: "Zapytanie nie znalezione",
    regTitle: "Rejestracje",
    regSubtitle: "Sprawdzaj i zarz\u0105dzaj rejestracjami firm",
    regFilterPending: "Oczekuj\u0105ce",
    regFilterApproved: "Zatwierdzone",
    regFilterRejected: "Odrzucone",
    regNew: "Nowa",
    regNoEntries: "Brak rejestracji w tej kategorii",
    regSelect: "Wybierz rejestracj\u0119",
    regApproved: "Rejestracja zatwierdzona – dane dost\u0119powe s\u0105 tworzone",
    regRejected: "Rejestracja odrzucona",
    regCreated: "Rejestracja utworzona",
    regUpdated: "Rejestracja zaktualizowana",
    regDeleted: "Rejestracja usuni\u0119ta",
    regDeleteTitle: "Usun\u0105\u0107 rejestracj\u0119?",
    regDeleteDesc: "Rejestracja firmy <strong>{{company}}</strong> zostanie trwale usuni\u0119ta.",
    oppTitle: "Matching projekt\u00F3w",
    oppSubtitle: "Monitoruj wszystkie dopasowane zapytania",
    filterNew: "Nowe",
    filterInReview: "W przegl\u0105dzie",
    filterFailed: "Nieudane",
    filterHold: "Wstrzymane",
    colScore: "Wynik",
    colDelivery: "Dostarczenie",
    selectOpp: "Wybierz zapytanie",
    resend: "Wy\u015Blij ponownie",
    resendTriggered: "Ponowne wys\u0142anie uruchomione",
    labelHoldReason: "Pow\u00F3d wstrzymania",
    labelRequestCompany: "Firma (zapytanie)",
    labelRequestEmail: "E-mail (zapytanie)",
    labelLocation: "Lokalizacja",
    claimTitle: "Reklamacje",
    claimSubtitle: "Przegl\u0105daj i decyduj o reklamacjach",
    claimFilterOpen: "Otwarte",
    claimFilterDecided: "Zdecydowane",
    claimNone: "Brak reklamacji",
    claimSelectDetail: "Wybierz reklamacj\u0119 dla szczeg\u00F3\u0142\u00F3w",
    claimDetailTitle: "Szczeg\u00F3\u0142y reklamacji",
    claimReason: "Pow\u00F3d",
    claimComment: "Komentarz",
    claimOppPrice: "Cena szansy",
    claimSubmittedAt: "Z\u0142o\u017Cono dnia",
    claimOperatorNote: "Notatka operatora",
    claimCredit: "Kredyt (centy)",
    claimApprove: "Zatwierd\u017A",
    claimReject: "Odrzu\u0107",
    claimApproved: "Reklamacja zatwierdzona",
    claimRejected: "Reklamacja odrzucona",
    billTitle: "Monitor rozlicze\u0144",
    billSubtitle: "Rozliczenia, mandaty i status wysy\u0142ki",
    billOverdue: "Przeterminowane",
    billMandate: "Metody p\u0142atno\u015Bci",
    billEmailFailures: "B\u0142\u0119dy e-mail",
    billMonthClose: "Zamkni\u0119cie miesi\u0105ca",
    billInvoices: "Faktury",
    billCloseMonth: "Zamknij miesi\u0105c",
    billClosing: "Zamykanie...",
    billMonthClosed: "Miesi\u0105c {{month}} zamkni\u0119ty",
    noEntries: "Brak wpis\u00F3w",
    colOverdueSince: "Przeterminowane od",
    colMethods: "Metody",
    colOpportunity: "Szansa",
    colError: "B\u0142\u0105d",
    colAttempts: "Pr\u00F3by",
    colMonth: "Miesi\u0105c",
    colAmount: "Kwota",
    colNet: "Netto",
    colGross: "Brutto",
    colPeriod: "Okres",
    costTitle: "Przegl\u0105d koszt\u00F3w",
    costSubtitle: "Zaakceptowane zapytania na firm\u0119 · Rozliczenie miesi\u0119czne",
    costProviders: "Firmy",
    costAccepted: "Zaakceptowane zapytania",
    costTotal: "Suma ({{month}})",
    costVatNote: "netto · Rozliczenie na koniec miesi\u0105ca",
    costNoAccepted: "Brak zaakceptowanych zapyta\u0144 w {{month}}",
    colAccepted: "Zaakceptowane",
    colAmountNet: "Kwota (netto)",
    colAmountGross: "Kwota (brutto)",
    costTotalRow: "Suma",
    costFooter: "Wszystkie kwoty w EUR · VAT 19% · Rozliczenie na koniec miesi\u0105ca kalendarzowego",
    auditTitle: "Dziennik audytu",
    auditSubtitle: "Globalny protok\u00F3\u0142 aktywno\u015Bci",
    auditAllEntities: "Wszystkie encje",
    auditAllEvents: "Wszystkie zdarzenia",
    auditRetention: "Retencja",
    auditCSV: "Eksport CSV",
    auditRetentionLabel: "Automatycznie usuwaj wpisy po:",
    auditDays: "Dni",
    auditSaved: "Retencja ustawiona na {{days}} dni",
    auditPurgeConfirm: "Usun\u0105\u0107 teraz wszystkie wpisy starsze ni\u017C {{days}} dni?",
    auditPurged: "Stare wpisy usuni\u0119te",
    auditPurgeNow: "Wyczy\u015B\u0107 teraz",
    auditCurrentRetention: "Obecnie zapisano: <span>{{days}} dni</span>.",
    colTimestamp: "Znacznik czasu",
    colEvent: "Zdarzenie",
    colEntity: "Encja",
    colActor: "Aktor",
    colMeta: "Meta",
    auditEntries: "{{count}} wpis\u00F3w · Strona {{page}} z {{total}}",
    setTitle: "Ustawienia",
    setSubtitle: "Konfiguracja platformy",
    setProviderTemplates: "Szablony firmy",
    setCustomerTemplates: "Szablony klienta",
    setGraph: "Microsoft Graph",
    setUsers: "Zarz\u0105dzanie u\u017Cytkownikami",
    setApiKeys: "Klucze API",
    setSaveTemplates: "Zapisz szablony",
    setTemplatesSaved: "Szablony e-mail zapisane",
    setGraphTitle: "Microsoft Graph API",
    setGraphDesc: "Konfiguracja wysy\u0142ki e-mail przez Graph API (Mail.Send)",
    setTenantId: "Tenant ID",
    setClientId: "Client ID",
    setClientSecret: "Client Secret",
    setSenderEmail: "E-mail nadawcy",
    setRetryPolicy: "Polityka ponowie\u0144",
    setMaxAttempts: "Maks. pr\u00F3b",
    setIntervals: "Interwa\u0142y (min)",
    setIntervalsHint: "Oddzielone przecinkami, np. 5,10,30",
    setSaveGraph: "Zapisz ustawienia Graph",
    setSavingGraph: "Zapisywanie...",
    setGraphSaved: "Ustawienia Microsoft Graph zapisane",
    setTestEmail: "Wy\u015Blij testowy e-mail",
    setTestTitle: "Wy\u015Blij testowy e-mail",
    setTestDesc: "Wprowad\u017A adres odbiorcy dla testowego e-maila przez Microsoft Graph.",
    setTestRecipient: "E-mail odbiorcy",
    setTestSending: "Wysy\u0142anie...",
    setTestSend: "Wy\u015Blij",
    setTestSent: "Testowy e-mail wys\u0142any do {{email}}",
    profTitle: "M\u00F3j profil",
    profSubtitle: "Ustawienia osobiste i bezpiecze\u0144stwo",
    profAccess: "Dost\u0119p operatora",
    profDisplayName: "Nazwa wy\u015Bwietlana",
    profDisplayNamePlaceholder: "Twoje imi\u0119",
    profSaveName: "Zapisz nazw\u0119",
    profNameSaved: "Nazwa zapisana",
    profChangePassword: "Zmie\u0144 has\u0142o",
    profNewPassword: "Nowe has\u0142o",
    profNewPasswordPlaceholder: "Co najmniej 6 znak\u00F3w",
    profConfirmPassword: "Potwierd\u017A has\u0142o",
    profConfirmPasswordPlaceholder: "Powt\u00F3rz has\u0142o",
    profPasswordChanged: "Has\u0142o zmienione pomy\u015Blnie",
    profPasswordMinLength: "Has\u0142o musi mie\u0107 co najmniej 6 znak\u00F3w",
    profPasswordMismatch: "Has\u0142a nie pasuj\u0105 do siebie",
    profAccountDetails: "Szczeg\u00F3\u0142y konta",
    profEmail: "E-mail",
    profCreatedAt: "Konto utworzono",
    profLastSignIn: "Ostatnie logowanie",
    profSaving: "Zapisywanie...",
    pricTitle: "Cennik",
    pricSubtitle: "Plany, dodatki i konfiguracja cen",
    pricPlans: "Plany",
    pricAddons: "Dodatki",
    pricPreview: "Podgl\u0105d strony cennika",
    pricNewPlan: "Nowy plan",
    pricEditPlan: "Edytuj plan",
    pricPlanSaved: "Plan zapisany",
    pricPlanDeleted: "Plan usuni\u0119ty",
    pricDeleteConfirm: "Usun\u0105\u0107 plan?",
    pricNewAddon: "Nowy dodatek",
    pricEditAddon: "Edytuj dodatek",
    pricAddonSaved: "Dodatek zapisany",
    pricAddonDeleted: "Dodatek usuni\u0119ty",
    pricKey: "Klucz",
    pricName: "Nazwa",
    pricPriceCents: "Cena (centy)",
    pricInclLeads: "Wliczone leady",
    pricMaxDeliveries: "Maks. dostawy",
    pricMaxRadius: "Maks. promie\u0144 (km)",
    pricMaxTrades: "Maks. bran\u017Ce",
    pricSort: "Sortowanie",
    pricFeaturesJSON: "Funkcje (tablica JSON)",
    pricActiveLabel: "Aktywny",
    pricInactive: "Nieaktywny",
    pricEdit: "Edytuj",
    pricExtraLeads: "Dodatkowe leady",
    matchTitle: "Matching",
    matchSubtitle: "Konfiguracja silnika dopasowa\u0144",
    matchWeights: "Wagi",
    matchLimits: "Limity i uczciwo\u015B\u0107",
    matchAI: "AI Matching",
    matchScoreWeights: "Wagi punkt\u00F3w",
    matchScoreDesc: "Podzia\u0142 100 punkt\u00F3w na wymiary dopasowania.",
    matchCurrent: "Aktualnie:",
    matchStackMatch: "Dopasowanie bran\u017Cowe",
    matchStackMatchDesc: "Zgodno\u015B\u0107 profilu firmy z zapytaniem",
    matchUrgencyFit: "SLA / Pilno\u015B\u0107",
    matchUrgencyFitDesc: "Czas reakcji SLA vs. pilno\u015B\u0107 zapytania",
    matchGeoFit: "Geografia",
    matchGeoFitDesc: "Zgodno\u015B\u0107 lokalizacji i pracy zdalnej",
    matchReliability: "Niezawodno\u015B\u0107",
    matchReliabilityDesc: "Wska\u017Anik akceptacji i czas reakcji firmy",
    matchQuality: "Jako\u015B\u0107",
    matchQualityDesc: "Wewn\u0119trzny wynik jako\u015Bci firmy",
    matchLimitsTitle: "Limity i uczciwo\u015B\u0107",
    matchLimitsDesc: "Sterowanie wyborem firm i regu\u0142y uczciwo\u015Bci",
    matchMaxProviders: "Maks. firm na zapytanie",
    matchMaxProvidersDesc: "Ile firm jest dopasowywanych do zapytania",
    matchMinScore: "Min. pr\u00F3g wyniku",
    matchMinScoreDesc: "Firmy poni\u017Cej tego wyniku s\u0105 wykluczone",
    matchFairnessDelta: "Delta uczciwo\u015Bci",
    matchFairnessDeltaDesc: "R\u00F3\u017Cnica punkt\u00F3w dla rotacji uczciwo\u015Bci",
    matchExpiryHours: "Czas wyga\u015Bni\u0119cia (godziny)",
    matchExpiryDesc: "Zapytanie wygasa po tym czasie",
    matchOverage: "Tolerancja przekroczenia (%)",
    matchOverageDesc: "= Firma mo\u017Ce przekroczy\u0107 sw\u00F3j limit miesi\u0119czny o {{percent}}%",
    matchOverageExample: "Przyk\u0142ad: Przy limicie 20 i 20% tolerancji firma mo\u017Ce przyj\u0105\u0107 do 24 zapyta\u0144",
    matchSaveConfig: "Zapisz konfiguracj\u0119",
    matchSaving: "Zapisywanie...",
    matchSaved: "Konfiguracja matchingu zapisana",
    matchWeightError: "Wagi musz\u0105 sumowa\u0107 si\u0119 do 100 (obecnie: {{total}})",
    matchAITitle: "Matching wspomagany AI",
    matchAIDesc: "Analiza i ocena zapyta\u0144 wspomagana AI",
    matchAIModel: "Model AI",
    matchAIFunctions: "Funkcje AI",
    matchAIEnhanceReasons: "Ulepsz uzasadnienia",
    matchAIEnhanceReasonsDesc: "AI generuje szczeg\u00F3\u0142owe wyja\u015Bnienia dlaczego firma pasuje",
    matchAIAdjustScores: "Korekty wyniku",
    matchAIAdjustScoresDesc: "AI mo\u017Ce dostosowywa\u0107 wyniki na podstawie analizy kontekstu",
    matchAIMaxAdjustment: "Maks. korekta wyniku (\u00B1)",
    matchAIMaxAdjustmentDesc: "Maksymalne punkty, kt\u00F3re AI mo\u017Ce doda\u0107/odj\u0105\u0107",
    matchAIHowTitle: "Jak dzia\u0142a matching AI",
    fbTitle: "Feedback",
    fbSubtitle: "Zarz\u0105dzaj i wysy\u0142aj opinie klient\u00F3w",
    fbRequests: "Zapytania",
    fbConfig: "Konfiguracja",
    fbWonWithout: "Wygrane zapytania bez feedbacku ({{count}})",
    fbSend: "Wy\u015Blij",
    fbEmailSent: "E-mail z feedbackiem wys\u0142any",
    fbAllRequests: "Wszystkie zapytania o feedback",
    fbNoRequests: "Brak utworzonych zapyta\u0144 o feedback.",
    fbResend: "Wy\u015Blij ponownie",
    fbEmailResent: "E-mail wys\u0142any ponownie",
    fbResponses: "Odpowiedzi",
    fbNoResponses: "Brak odpowiedzi.",
    fbConfigDesc: "Skonfiguruj pytania widoczne w formularzu feedbacku.",
    fbEditQuestion: "Edytuj pytanie",
    fbNewQuestion: "Utwórz nowe pytanie",
    fbQuestionText: "Tekst pytania",
    fbType: "Typ",
    fbTypeRating: "Ocena gwiazdkowa",
    fbTypeText: "Tekst wolny",
    fbTypeYesNo: "Tak/Nie",
    fbTypeScale: "Skala (1-10)",
    fbSaved: "Zapisano",
    salesTitle: "Dashboard sprzeda\u017Cy",
    salesSubtitle: "KPI i pomoc argumentacyjna",
    salesTotalProviders: "\u0141\u0105cznie firm",
    salesActiveProviders: "Aktywne firmy",
    salesNewRegs7d: "Nowe rejestracje (7d)",
    salesAvgAcceptance: "\u015Ar. wska\u017Anik akceptacji",
    salesOpps30d: "Szanse (30d)",
    salesDelivered30d: "Dostarczone (30d)",
    salesRevenue: "Przych\u00F3d (miesi\u0105c)",
    salesAvgScore: "\u015Ar. wynik dopasowania",
    salesElevatorPitch: "Elevator Pitch (30 sek.)",
    salesCopy: "Kopiuj",
    salesCopied: "Skopiowano",
    salesTop5: "Top 5 argument\u00F3w sprzeda\u017Cowych",
    salesArgRiskFree: "Bez ryzyka",
    salesArgRiskFreeDesc: "Brak um\u00F3w, brak op\u0142at bazowych, p\u0142atno\u015B\u0107 tylko przy akceptacji",
    salesArgQuality: "Jako\u015B\u0107",
    salesArgQualityDesc: "Wst\u0119pnie kwalifikowane zapytania, matching algorytmiczny",
    salesArgFairness: "Uczciwo\u015B\u0107",
    salesArgFairnessDesc: "Maks. 3–5 konkurent\u00F3w, brak wojny cenowej",
    salesArgFast: "Szybko",
    salesArgFastDesc: "Rejestracja w 15 minut, pierwsze leady w ci\u0105gu godzin",
    salesArgFlexible: "Elastycznie",
    salesArgFlexibleDesc: "Tygodniowy limit regulowany, mo\u017Cliwo\u015B\u0107 pauzy w dowolnym momencie",
    salesStrongestNumbers: "3 najsilniejsze liczby",
    salesAcceptanceRate: "Wska\u017Anik akceptacji",
    salesResponseTime: "\u015Ar. czas reakcji",
    salesProvidersPerRequest: "Rzemie\u015Blnik\u00F3w na zapytanie",
    salesObjectionHandling: "Obs\u0142uga zastrze\u017Ce\u0144",
    salesBenchmarks: "Benchmarki KPI firm (do argumentacji)",
    salesKPI: "KPI",
    salesBenchmark: "Benchmark CRAFTFINDUS",
    roiTitle: "Kalkulator ROI",
    roiSubtitle: "Interaktywny kalkulator do rozm\u00F3w handlowych",
    roiParams: "Dostosuj parametry",
    roiLeadsPerMonth: "Lead\u00F3w miesi\u0119cznie",
    roiAvgLeadPrice: "\u015Ar. cena leada (\u20AC)",
    roiConversion: "Konwersja Lead \u2192 Klient (%)",
    roiAvgDealValue: "\u015Ar. warto\u015B\u0107 zam\u00F3wienia (\u20AC)",
    roiCurrentCAC: "Obecny koszt pozyskania klienta (\u20AC)",
    roiIndustryAvg: "\u015Arednia bran\u017Cowa: 1 500–3 000 \u20AC",
    roiScenarios: "Szybkie scenariusze",
    roiMonthlyCost: "Miesi\u0119czne koszty CRAFTFINDUS",
    roiExpectedCustomers: "Oczekiwani nowi klienci",
    roiExpectedRevenue: "Oczekiwany przych\u00F3d",
    roiLabel: "ROI",
    roiCACComparison: "Por\u00F3wnanie koszt\u00F3w pozyskania",
    roiCurrentCACLabel: "Obecny CAC",
    roiCraftfindusCAC: "CAC CRAFTFINDUS",
    roiSavingsPerCustomer: "Oszcz\u0119dno\u015B\u0107 na klienta",
    roiCurrent: "Obecne",
    roiWithCraftfindus: "Z CRAFTFINDUS",
    roiAnnualSavings: "Roczne oszcz\u0119dno\u015Bci na pozyskaniu klient\u00F3w",
    roiBasedOn: "Na podstawie {{count}} nowych klient\u00F3w/rok",
    roiTalkingPoint: "Punkt do rozmowy",
    pdTabProfile: "Profil i status",
    pdTabServices: "Us\u0142ugi i stack",
    pdMasterData: "Dane podstawowe",
    pdContact: "Kontakt",
    pdPhone: "Telefon",
    pdWebsite: "Strona www",
    pdCompanyType: "Typ firmy",
    pdRemote: "Zdalnie",
    pdSLA: "SLA",
    pdMonthlyLimit: "Limit miesi\u0119czny",
    pdAddress: "Adres",
    pdResendWelcome: "Wy\u015Blij ponownie e-mail powitalny",
    pdResetPassword: "Zresetuj has\u0142o",
    pdAdditionalContacts: "Dodatkowe osoby kontaktowe",
    pdStatusActions: "Status i akcje",
    pdApproved: "Zatwierdzony",
    pdSuspended: "Zawieszony",
    pdSuspendReason: "Pow\u00F3d zawieszenia:",
    pdSuspendedAt: "Zawieszony dnia:",
    pdFailedDebits: "Nieudane obci\u0105\u017Cenia:",
    pdApprove: "Zatwierd\u017A",
    pdSuspend: "Zawie\u015B r\u0119cznie",
    pdSuspendPrompt: "Pow\u00F3d zawieszenia:",
    pdUnsuspend: "Odblokuj",
    pdDelete: "Usu\u0144",
    pdDeleteTitle: "Usun\u0105\u0107 firm\u0119 rzemie\u015Blnicz\u0105?",
    pdDeleteDesc: "<strong>{{company}}</strong> zostanie trwale usuni\u0119ta.",
    pdDeleted: "Firma rzemie\u015Blnicza usuni\u0119ta",
    pdPayment: "Metoda p\u0142atno\u015Bci (Mollie)",
    pdPaymentStatus: "Status",
    pdSetupStatus: "Status konfiguracji",
    pdMollieCustomer: "Klient Mollie",
    pdPaymentMethods: "Metody",
    pdActivateManual: "Aktywuj r\u0119cznie",
    pdDeactivateManual: "Dezaktywuj r\u0119cznie",
    pdPaymentUpdated: "Status p\u0142atno\u015Bci zaktualizowany",
    pdActionSuccess: "Akcja {{action}} powiod\u0142a si\u0119",
    pdCategories: "Kategorie",
    pdNoCategories: "Brak przypisanych kategorii",
    pdStack: "Stack / Bran\u017Ce",
    pdNoStack: "Brak przypisanych tag\u00F3w stack",
    pdAuditLog: "Dziennik aktywno\u015Bci",
    pdNoAuditLog: "Brak aktywno\u015Bci",
    pcTitle: "Dodaj firm\u0119",
    pcSubtitle: "Wprowad\u017A now\u0105 firm\u0119 rzemie\u015Blnicz\u0105",
    pcCreateBtn: "Dodaj firm\u0119",
    pcCreating: "Tworzenie...",
    pcCreated: "Firma rzemie\u015Blnicza utworzona",
    pcRequiredFields: "Wype\u0142nij wymagane pola (Firma, Kontakt, E-mail)",
    pcLoginRequired: "Podaj e-mail logowania dla dost\u0119pu do portalu",
    pcCreateError: "B\u0142\u0105d podczas tworzenia",
    monthJan: "Stycze\u0144",
    monthFeb: "Luty",
    monthMar: "Marzec",
    monthApr: "Kwiecie\u0144",
    monthMay: "Maj",
    monthJun: "Czerwiec",
    monthJul: "Lipiec",
    monthAug: "Sierpie\u0144",
    monthSep: "Wrzesie\u0144",
    monthOct: "Pa\u017Adziernik",
    monthNov: "Listopad",
    monthDec: "Grudzień",
    regFilterAll: "Wszystkie",
    regEmpty: "Brak rejestracji w tej kategorii",
    regSelectHint: "Wybierz rejestrację",
    regApproveSuccess: "Rejestracja zatwierdzona – dane dostępowe są tworzone",
    regApproveError: "Błąd przy zatwierdzaniu",
    regRejectSuccess: "Rejestracja odrzucona",
    regRejectError: "Błąd przy odrzucaniu",
    regCreateSuccess: "Rejestracja utworzona",
    regUpdateSuccess: "Rejestracja zaktualizowana",
    regDeleteSuccess: "Rejestracja usunięta",
    regDeleteError: "Błąd przy usuwaniu",
    regDeleteConfirm: "Usuń trwale",
    oppFilterNew: "Nowe",
    oppFilterInReview: "W przeglądzie",
    oppFilterFailed: "Nieudane",
    oppFilterHold: "Wstrzymane",
    oppColNumber: "Nr",
    oppColCategory: "Kategoria",
    oppColProvider: "Firma",
    oppColScore: "Wynik",
    oppColStatus: "Status",
    oppColDelivery: "Dostarczenie",
    oppColPrice: "Cena",
    oppEmpty: "Brak zapytań",
    oppSelectHint: "Wybierz zapytanie",
    oppResend: "Wyślij ponownie",
    oppResendSuccess: "Ponowne wysłanie uruchomione",
    oppDetailUrgency: "Pilność",
    oppDetailCompany: "Firma (zapytanie)",
    oppDetailEmail: "E-mail (zapytanie)",
    oppDetailLocation: "Lokalizacja",
    oppDetailHoldReason: "Powód wstrzymania",
    claimEmpty: "Brak reklamacji",
    claimSelectHint: "Wybierz reklamację dla szczegółów",
    claimDetail: "Szczegóły reklamacji",
    claimCreditCents: "Kredyt (centy)",
    claimApproveSuccess: "Reklamacja zatwierdzona",
    claimRejectSuccess: "Reklamacja odrzucona",
    billingTitle: "Monitor rozliczeń",
    billingSubtitle: "Rozliczenia, mandaty i status wysyłki",
    billingOverdue: "Przeterminowane",
    billingMandate: "Metody płatności",
    billingEmailFailures: "Błędy e-mail",
    billingMonthClose: "Zamknięcie miesiąca",
    billingInvoices: "Faktury",
    billingCloseMonth: "Zamknij miesiąc",
    billingCloseSuccess: "Miesiąc {{month}} zamknięty",
    billingEmpty: "Brak wpisów",
    billingOverdueSince: "Przeterminowane od",
    billingMethods: "Metody",
    billingError: "Błąd",
    billingAttempts: "Próby",
    billingMonth: "Miesiąc",
    billingAmount: "Kwota",
    billingNet: "Netto",
    billingGross: "Brutto",
    billingPeriod: "Okres",
    colBillingStatus: "Status rozliczeń",
    profileTitle: "Mój profil",
    profileSubtitle: "Ustawienia osobiste i bezpieczeństwo",
    profileRole: "Dostęp operatora",
    profileDisplayName: "Nazwa wyświetlana",
    profileNamePlaceholder: "Twoje imię",
    profileSaveName: "Zapisz nazwę",
    profileNameSuccess: "Nazwa zapisana",
    profileNameError: "Błąd przy zapisywaniu nazwy",
    profileChangePassword: "Zmień hasło",
    profileNewPassword: "Nowe hasło",
    profilePasswordPlaceholder: "Co najmniej 6 znaków",
    profileConfirmPassword: "Potwierdź hasło",
    profileConfirmPlaceholder: "Powtórz hasło",
    profilePasswordSuccess: "Hasło zmienione pomyślnie",
    profilePasswordError: "Błąd przy zmianie hasła",
    profilePasswordMinLength: "Hasło musi mieć co najmniej 6 znaków",
    profilePasswordMismatch: "Hasła nie pasują do siebie",
    profileAccountDetails: "Szczegóły konta",
    profileEmail: "E-mail",
    profileCreatedAt: "Konto utworzono",
    profileLastLogin: "Ostatnie logowanie",
    createTitle: "Dodaj firmę",
    createSubtitle: "Wprowadź nową firmę rzemieślniczą",
    createSubmit: "Dodaj firmę",
    createSuccess: "Firma rzemieślnicza utworzona",
    createError: "Błąd podczas tworzenia",
    createRequiredFields: "Wypełnij wymagane pola (Firma, Kontakt, E-mail)",
    createLoginEmailRequired: "Podaj e-mail logowania dla dostępu do portalu",
  },
  aiSearch: {
    title: "Czym jest CRAFTFINDUS?",
    definition: "CRAFTFINDUS to cyfrowa platforma jakości do łączenia ze zweryfikowanymi firmami rzemieślniczymi w Niemczech, Austrii, Szwajcarii, Holandii, Belgii, Francji i Polsce. Zleceniodawcy opisują swój projekt – CRAFTFINDUS dzięki inteligentnemu matchingowi znajduje 3 do 5 odpowiednich, zweryfikowanych fachowców w regionie. Usługa jest bezpłatna i niezobowiązująca dla zleceniodawców. Firmy rzemieślnicze płacą transparentną stałą cenę za zaakceptowany kontakt – bez prowizji, bez zobowiązań umownych.",
    highlight1: "Zweryfikowane firmy: rejestracja, ubezpieczenie, zdolność kredytowa sprawdzone",
    highlight2: "Maks. 3–5 firm na projekt: uczciwe szanse, bez wojny cenowej",
    highlight3: "Transparentne ceny: stałe ceny kontaktu, bez ukrytych opłat",
    highlight4: "Uczciwy proces reklamacji: zwrot za niekwalifikowane kontakty",
  },
  seoLanding: {
    verified: "Zweryfikowane firmy",
    free: "Bezpłatnie i niezobowiązująco",
    fast: "Odpowiedź w 24h",
    ctaRequest: "Złóż zapytanie teraz",
    freeForClients: "Bezpłatnie dla klientów",
    whatIsCraftfindus: "Czym jest CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS to cyfrowa platforma łącząca klientów ze zweryfikowanymi firmami rzemieślniczymi w Niemczech, Austrii, Szwajcarii, Belgii, Holandii, Francji i Polsce. Opisujesz swój projekt – my znajdujemy 3 do 5 pasujących firm w Twojej okolicy. Bezpłatnie i niezobowiązująco.",
    verifiedProviders: "Zweryfikowani {{trade}} w {{city}}",
    howItWorks: "Jak działa CRAFTFINDUS",
    costs: "Koszty i ceny {{trade}}",
    inCity: "w {{city}}",
    faq: "Często zadawane pytania",
    ctaHeading: "Szukasz {{trade}} w {{city}}?",
    ctaSubtext: "Złóż bezpłatne zapytanie i otrzymaj do 5 ofert od zweryfikowanych firm.",
    relatedCities: "{{trade}} w innych miastach",
    otherTrades: "Inne branże w {{city}}",
    relatedArticles: "Powiązane poradniki",
  },
  blog: {
    title: "Poradnik CRAFTFINDUS",
    description: "Porady, koszty i poradniki dotyczące projektów rzemieślniczych",
    noPosts: "Brak artykułów.",
    backToList: "Powrót do poradnika",
  },
  warum: {
    seoTitle: "Dlaczego CRAFTFINDUS – Platforma jakości dla rzemiosła",
    seoDesc: "Dowiedz się, dlaczego CRAFTFINDUS jest inny: kontrola jakości leadów, transparentne ceny, zweryfikowane firmy i uczciwy proces reklamacji.",
    heroLabel: "Dlaczego CRAFTFINDUS",
    heroTitle1: "Dopasowanie rzemieślnicze,",
    heroTitle2: "jakie powinno być.",
    heroDesc: "Większość platform dystrybuuje kontakty. My łączymy zakwalifikowane projekty ze zweryfikowanymi firmami – uczciwie, transparentnie i zorientowanie na wyniki.",
    problemLabel: "Problem rynkowy",
    problemTitle: "Co idzie nie tak na innych platformach",
    problem1Title: "Niekwalifikowane zapytania",
    problem1Desc: "Kontakty bez budżetu, bez prawdziwego projektu, bez zweryfikowanych danych. Płacisz za leady, które nigdy nie stają się zleceniami.",
    problem2Title: "Nieprzejrzyste koszty",
    problem2Desc: "Ukryte opłaty, prowizje od zleceń, niejasne modele cenowe.",
    problem3Title: "Masowa dystrybucja",
    problem3Desc: "Twoje zapytanie trafia do 10, 15 lub 20 firm jednocześnie. Wynik: wojny cenowe, kopiuj-wklej oferty, frustracja.",
    problem4Title: "Brak prawa do reklamacji",
    problem4Desc: "Kontakt nieosiągalny? Zła branża? Pech. Na większości platform nie ma uczciwego rozwiązania.",
    solutionLabel: "Nasze podejście",
    solutionTitle: "Co CRAFTFINDUS robi inaczej",
    solution1Title: "Ocena jakości leadów",
    solution1Desc: "Każde zapytanie jest automatycznie oceniane: telefon zweryfikowany, budżet podany, opis obecny. Tylko zapytania z wynikiem > 60 są fakturowane.",
    solution2Title: "Transparentne ceny kontaktów",
    solution2Desc: "Stałe ceny za kontakt – widoczne z góry. Bez prowizji, bez ukrytych opłat.",
    solution3Title: "Max. 3-5 firm na projekt",
    solution3Desc: "Każde zapytanie trafia do maksymalnie 5 zweryfikowanych firm. Mniej konkurencji, wyższe wskaźniki zamknięcia.",
    solution4Title: "Uczciwy proces reklamacji",
    solution4Desc: "Kontakt nieosiągalny? Zła branża? Otrzymujesz zwrot ceny kontaktu – w ciągu 72 godzin, gwarantowane.",
    solution5Title: "Zweryfikowane firmy",
    solution5Desc: "Rejestracja działalności, ubezpieczenie, zdolność kredytowa – nasze firmy przechodzą wieloetapowy proces weryfikacji.",
    solution6Title: "Mechanizm uczciwości",
    solution6Desc: "Automatyczne wykrywanie nadużyć, dashboard transparentności i maksymalne wskaźniki reklamacji chronią jakość platformy.",
    ctaTitle: "Przekonany?",
    ctaClientBtn: "Rozpocznij projekt profesjonalnie",
    ctaProviderBtn: "Zabezpiecz więcej kwalifikowanych projektów",
  },
  inquiryPsych: {
    qualityHint: "Im dokładniejsze Twoje dane, tym lepsze firmy otrzymasz.",
    timePromise: "Zajmuje mniej niż 2 minuty",
    matchingHint: "Sprawdzamy Twoje zapytanie przed przekazaniem do pasujących firm.",
    descShort: "Proszę opisz swój projekt bardziej szczegółowo.",
    descGood: "Bardzo dobry opis – to zwiększa Twoje szanse na szybkie oferty.",
    photoHint: "Zdjęcia pomagają w dokładnej ocenie.",
  },
  quality: {
    seoTitle: "Obietnica jakości – Jak działa CRAFTFINDUS",
    seoDesc: "Dowiedz się transparentnie, jak weryfikujemy projekty, sprawdzamy firmy, uczciwie fakturujemy i obsługujemy reklamacje.",
    heroLabel: "Nasza obietnica jakości",
    heroTitle1: "Transparentność.",
    heroTitle2: "Nie tylko obietnica.",
    heroDesc: "Wyjaśniamy dokładnie, jak działa nasza platforma – od weryfikacji projektu do reklamacji.",
    sec1Title: "Jak projekty są weryfikowane",
    sec1Desc: "Każde zapytanie przechodzi przez nasz automatyczny silnik jakości. Tylko zapytania z wynikiem co najmniej 60 punktów są przekazywane firmom.",
    sec1Item1: "Numer telefonu zweryfikowany (+20 punktów)",
    sec1Item2: "Budżet podany (+25 punktów)",
    sec1Item3: "Opis projektu sprawdzony (+10 punktów)",
    sec1Item4: "Dane kontaktowe kompletne (+10 punktów)",
    sec2Title: "Jak firmy są weryfikowane",
    sec2Desc: "Nasze firmy przechodzą wieloetapowy proces weryfikacji. Tylko zweryfikowane firmy otrzymują zapytania projektowe.",
    sec2Item1: "Rejestracja działalności sprawdzona (Poziom 1)",
    sec2Item2: "Ubezpieczenie OC zweryfikowane (Poziom 2)",
    sec2Item3: "Sprawdzenie zdolności kredytowej (Poziom 3)",
    sec2Item4: "Weryfikacja tożsamości zakończona (Poziom 3)",
    sec3Title: "Jak działa fakturowanie",
    sec3Desc: "Transparentne, przewidywalne koszty. Bez ukrytych opłat, bez prowizji od zleceń.",
    sec3Item1: "Stałe ceny za kontakt – widoczne z góry",
    sec3Item2: "Elastyczne modele: Flex, Professional, Premium",
    sec3Item3: "Miesięczne fakturowanie, możliwość rezygnacji w dowolnym momencie",
    sec4Title: "Jak działają reklamacje",
    sec4Desc: "Uczciwy proces przy uzasadnionych skargach. Zwrot w ciągu 72 godzin.",
    sec4Item1: "Reklamacja bezpośrednio w dashboardzie",
    sec4Item2: "Powody: Nieosiągalny, zła branża, to nie prawdziwy projekt",
    sec4Item3: "Uzasadnione reklamacje są natychmiast zwracane",
    ctaTitle: "Jeszcze pytania?",
    ctaDesc: "Skontaktuj się z nami lub zacznij od razu – stoimy za transparentnością i uczciwością.",
    ctaClientBtn: "Rozpocznij projekt profesjonalnie",
    ctaProviderBtn: "Zabezpiecz więcej kwalifikowanych projektów",
  },
};

export default pl;
